import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, Component, Input, ViewEncapsulation, ChangeDetectionStrategy, inject, ElementRef, signal, computed, Directive, ChangeDetectorRef, EnvironmentInjector, TemplateRef, ContentChild, ViewChild, EventEmitter, ContentChildren, Output, Optional, ViewContainerRef, HostBinding, Inject, Renderer2, Injectable } from '@angular/core';
import * as i1$1 from '@skyux/core';
import { SkyContentInfoProvider, SkyAffixService, SkyIdService, SkyOverlayService, SKY_STACKING_CONTEXT, SkyAffixAutoFitContext, SkyAffixModule, SkyIdModule, SkyScreenReaderLabelDirective } from '@skyux/core';
import * as i3 from '@skyux/icon';
import { SkyIconModule } from '@skyux/icon';
import * as i3$1 from '@skyux/theme';
import { SkyThemeService, SkyThemeModule } from '@skyux/theme';
import * as i6 from '@skyux/i18n';
import { SkyLibResourcesService, SkyI18nModule } from '@skyux/i18n';
import { Subject, of, switchMap, fromEvent, takeUntil as takeUntil$1, debounceTime, animationFrameScheduler, map, distinctUntilChanged } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import { trigger, state, transition, style, animate } from '@angular/animations';

/* istanbul ignore file */
/**
 * NOTICE: DO NOT MODIFY THIS FILE!
 * The contents of this file were automatically generated by
 * the 'ng generate @skyux/i18n:lib-resources-module lib/modules/shared/sky-popovers' schematic.
 * To update this file, simply rerun the command.
 */
const RESOURCES = {
    'EN-US': {
        skyux_dropdown_context_menu_default_label: { message: 'Context menu' },
        skyux_dropdown_context_menu_with_content_descriptor_default_label: {
            message: 'Context menu for {0}',
        },
        skyux_dropdown_context_menu_with_content_descriptor_el_default_label: {
            message: 'Context menu for ',
        },
    },
    'FR-CA': {
        skyux_dropdown_context_menu_default_label: { message: 'Menu du contexte' },
        skyux_dropdown_context_menu_with_content_descriptor_default_label: {
            message: 'Menu du contexte pour {0}',
        },
        skyux_dropdown_context_menu_with_content_descriptor_el_default_label: {
            message: 'Menu du contexte pour ',
        },
    },
};
SkyLibResourcesService.addResources(RESOURCES);
/**
 * Import into any component library module that needs to use resource strings.
 */
class SkyPopoversResourcesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoversResourcesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoversResourcesModule, exports: [SkyI18nModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoversResourcesModule, imports: [SkyI18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoversResourcesModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [SkyI18nModule],
                }]
        }] });

/**
 * Specifies the button for the dropdown menu.
 */
class SkyDropdownButtonComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.7", type: SkyDropdownButtonComponent, isStandalone: false, selector: "sky-dropdown-button", ngImport: i0, template: "<ng-content />\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-dropdown-button', standalone: false, template: "<ng-content />\n" }]
        }] });

/**
 * Specifies the items to display on the dropdown menu.
 */
class SkyDropdownItemComponent {
    /**
     * The ARIA role for the dropdown menu item
     * [to support accessibility](https://developer.blackbaud.com/skyux/learn/accessibility)
     * by indicating how the item functions and what it controls. For information about
     * how an ARIA role indicates what an item represents on a web page, see the
     * [WAI-ARIA roles model](https://www.w3.org/WAI/PF/aria/#roles).
     * @default "menuitem"
     */
    set ariaRole(value) {
        this.#_ariaRole = value ?? 'menuitem';
    }
    get ariaRole() {
        return this.#_ariaRole;
    }
    #_ariaRole;
    #changeDetector;
    #renderer;
    constructor(elementRef, changeDetector, renderer) {
        this.elementRef = elementRef;
        this.isActive = false;
        this.#_ariaRole = 'menuitem';
        this.#changeDetector = changeDetector;
        this.#renderer = renderer;
    }
    ngAfterViewInit() {
        // Make sure anchor elements are tab-able.
        const buttonElement = this.#getButtonElement();
        /* istanbul ignore else */
        if (buttonElement) {
            this.#renderer.setAttribute(buttonElement, 'tabIndex', '0');
        }
        this.#changeDetector.detectChanges();
    }
    focusElement(enableNativeFocus) {
        this.isActive = true;
        if (enableNativeFocus) {
            this.#getButtonElement()?.focus();
        }
        this.#changeDetector.detectChanges();
    }
    isFocusable() {
        const isFocusable = this.#getButtonElement()?.getAttribute('disabled') === null;
        return isFocusable;
    }
    resetState() {
        this.isActive = false;
        this.#changeDetector.markForCheck();
    }
    #getButtonElement() {
        return this.elementRef.nativeElement.querySelector('button,a');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownItemComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.7", type: SkyDropdownItemComponent, isStandalone: false, selector: "sky-dropdown-item", inputs: { ariaRole: "ariaRole" }, ngImport: i0, template: "<div\n  class=\"sky-dropdown-item\"\n  [attr.role]=\"ariaRole\"\n  [ngClass]=\"{\n    'sky-dropdown-item-active': isActive\n  }\"\n>\n  <ng-content />\n</div>\n", styles: [".sky-dropdown-item:not(.sky-theme-modern *){--sky-override-dropdown-item-active-class-background: #eeeeef;--sky-override-dropdown-item-border-radius: 0px;--sky-override-dropdown-item-box-shadow: none;--sky-override-dropdown-item-color-background: transparent;--sky-override-dropdown-item-color-text: #212327;--sky-override-dropdown-item-disabled-color-background: transparent;--sky-override-dropdown-item-disabled-color-text: var( --sky-text-color-deemphasized );--sky-override-dropdown-item-disabled-box-shadow: none;--sky-override-dropdown-item-disabled-font-size: 15px;--sky-override-dropdown-item-disabled-font-style: italic;--sky-override-dropdown-item-focus-visible-background: #eeeeef;--sky-override-dropdown-item-hover-background: #eeeeef;--sky-override-dropdown-item-margin: 4px;--sky-override-dropdown-item-padding: 3px 20px}.sky-theme-modern:not(.sky-theme-brand-base) .sky-dropdown-item{--sky-override-dropdown-item-disabled-box-shadow: none;--sky-override-dropdown-item-disabled-color-background: transparent;--sky-override-dropdown-item-disabled-font-size: 15px;--sky-override-dropdown-item-disabled-font-style: italic}.sky-dropdown-item{background-color:var(--sky-override-dropdown-item-color-background, --sky-color-background-action-tertiary-base);border:none;display:block;margin:var(--sky-override-dropdown-item-margin, 0);min-width:160px;text-align:left;transition:box-shadow .15s}.sky-dropdown-item.sky-dropdown-item-active a,.sky-dropdown-item.sky-dropdown-item-active button{background-color:var(--sky-override-dropdown-item-active-class-background, var(--sky-color-background-action-tertiary-active))}.sky-dropdown-item>a,.sky-dropdown-item>button{border-radius:var(--sky-override-dropdown-item-border-radius, var(--sky-border-radius-s));background-color:var(--sky-override-dropdown-item-color-background, --sky-color-background-action-tertiary-base);box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-base) var(--sky-color-border-action-tertiary-base));border:none;color:var(--sky-override-dropdown-item-color-text, var(--sky-color-text-default));cursor:pointer;display:block;padding:var(--sky-override-dropdown-item-padding, var(--sky-space-inset-pillarbox-1_2-top-m) var(--sky-space-inset-pillarbox-1_2-left-m) var(--sky-space-inset-pillarbox-1_2-bottom-m) var(--sky-space-inset-pillarbox-1_2-right-m));text-align:left;width:100%}.sky-dropdown-item>a:hover,.sky-dropdown-item>button:hover{text-decoration:none;background-color:var(--sky-override-dropdown-item-hover-background, var(--sky-color-background-action-tertiary-hover));box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-hover) var(--sky-color-border-action-tertiary-hover))}.sky-dropdown-item>a:active,.sky-dropdown-item>button:active{background-color:var(--sky-override-dropdown-item-color-background, var(--sky-color-background-action-tertiary-active));box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-active) var(--sky-color-border-action-tertiary-active))}.sky-dropdown-item>a:focus-visible:not(:active),.sky-dropdown-item>button:focus-visible:not(:active){background-color:var(--sky-override-dropdown-item-focus-visible-background, var(--sky-color-background-action-tertiary-focus));box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-focus) var(--sky-color-border-action-tertiary-focus), var(--sky-elevation-focus))}.sky-dropdown-item>a[disabled],.sky-dropdown-item>a[disabled]:hover,.sky-dropdown-item>a[disabled]:focus-visible,.sky-dropdown-item>a[disabled]:active,.sky-dropdown-item>button[disabled],.sky-dropdown-item>button[disabled]:hover,.sky-dropdown-item>button[disabled]:focus-visible,.sky-dropdown-item>button[disabled]:active{box-shadow:var(--sky-override-dropdown-item-disabled-box-shadow, inset 0 0 0 var(--sky-border-width-action-disabled) var(--sky-color-border-action-tertiary-disabled));background-color:var(--sky-override-dropdown-item-disabled-color-background, var(--sky-color-background-action-tertiary-disabled));color:var(--sky-override-dropdown-item-disabled-color-text, var(--sky-color-text-deemphasized));cursor:default;font-size:var(--sky-override-dropdown-item-disabled-font-size, inherit);font-style:var(--sky-override-dropdown-item-disabled-font-style, inherit)}.sky-dropdown-item>a[disabled]:focus-visible,.sky-dropdown-item>a[disabled]:hover:focus-visible,.sky-dropdown-item>a[disabled]:focus-visible:focus-visible,.sky-dropdown-item>a[disabled]:active:focus-visible,.sky-dropdown-item>button[disabled]:focus-visible,.sky-dropdown-item>button[disabled]:hover:focus-visible,.sky-dropdown-item>button[disabled]:focus-visible:focus-visible,.sky-dropdown-item>button[disabled]:active:focus-visible{box-shadow:var(--sky-override-dropdown-item-disabled-box-shadow, inset 0 0 0 var(--sky-border-width-action-disabled) var(--sky-color-border-action-tertiary-disabled))}:host-context(.sky-theme-modern) .sky-dropdown-item>a,:host-context(.sky-theme-modern) .sky-dropdown-item>button{outline:none}.sky-theme-modern .sky-dropdown-item>a,.sky-theme-modern .sky-dropdown-item>button{outline:none}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-dropdown-item', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, standalone: false, template: "<div\n  class=\"sky-dropdown-item\"\n  [attr.role]=\"ariaRole\"\n  [ngClass]=\"{\n    'sky-dropdown-item-active': isActive\n  }\"\n>\n  <ng-content />\n</div>\n", styles: [".sky-dropdown-item:not(.sky-theme-modern *){--sky-override-dropdown-item-active-class-background: #eeeeef;--sky-override-dropdown-item-border-radius: 0px;--sky-override-dropdown-item-box-shadow: none;--sky-override-dropdown-item-color-background: transparent;--sky-override-dropdown-item-color-text: #212327;--sky-override-dropdown-item-disabled-color-background: transparent;--sky-override-dropdown-item-disabled-color-text: var( --sky-text-color-deemphasized );--sky-override-dropdown-item-disabled-box-shadow: none;--sky-override-dropdown-item-disabled-font-size: 15px;--sky-override-dropdown-item-disabled-font-style: italic;--sky-override-dropdown-item-focus-visible-background: #eeeeef;--sky-override-dropdown-item-hover-background: #eeeeef;--sky-override-dropdown-item-margin: 4px;--sky-override-dropdown-item-padding: 3px 20px}.sky-theme-modern:not(.sky-theme-brand-base) .sky-dropdown-item{--sky-override-dropdown-item-disabled-box-shadow: none;--sky-override-dropdown-item-disabled-color-background: transparent;--sky-override-dropdown-item-disabled-font-size: 15px;--sky-override-dropdown-item-disabled-font-style: italic}.sky-dropdown-item{background-color:var(--sky-override-dropdown-item-color-background, --sky-color-background-action-tertiary-base);border:none;display:block;margin:var(--sky-override-dropdown-item-margin, 0);min-width:160px;text-align:left;transition:box-shadow .15s}.sky-dropdown-item.sky-dropdown-item-active a,.sky-dropdown-item.sky-dropdown-item-active button{background-color:var(--sky-override-dropdown-item-active-class-background, var(--sky-color-background-action-tertiary-active))}.sky-dropdown-item>a,.sky-dropdown-item>button{border-radius:var(--sky-override-dropdown-item-border-radius, var(--sky-border-radius-s));background-color:var(--sky-override-dropdown-item-color-background, --sky-color-background-action-tertiary-base);box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-base) var(--sky-color-border-action-tertiary-base));border:none;color:var(--sky-override-dropdown-item-color-text, var(--sky-color-text-default));cursor:pointer;display:block;padding:var(--sky-override-dropdown-item-padding, var(--sky-space-inset-pillarbox-1_2-top-m) var(--sky-space-inset-pillarbox-1_2-left-m) var(--sky-space-inset-pillarbox-1_2-bottom-m) var(--sky-space-inset-pillarbox-1_2-right-m));text-align:left;width:100%}.sky-dropdown-item>a:hover,.sky-dropdown-item>button:hover{text-decoration:none;background-color:var(--sky-override-dropdown-item-hover-background, var(--sky-color-background-action-tertiary-hover));box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-hover) var(--sky-color-border-action-tertiary-hover))}.sky-dropdown-item>a:active,.sky-dropdown-item>button:active{background-color:var(--sky-override-dropdown-item-color-background, var(--sky-color-background-action-tertiary-active));box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-active) var(--sky-color-border-action-tertiary-active))}.sky-dropdown-item>a:focus-visible:not(:active),.sky-dropdown-item>button:focus-visible:not(:active){background-color:var(--sky-override-dropdown-item-focus-visible-background, var(--sky-color-background-action-tertiary-focus));box-shadow:var(--sky-override-dropdown-item-box-shadow, inset 0 0 0 var(--sky-border-width-action-focus) var(--sky-color-border-action-tertiary-focus), var(--sky-elevation-focus))}.sky-dropdown-item>a[disabled],.sky-dropdown-item>a[disabled]:hover,.sky-dropdown-item>a[disabled]:focus-visible,.sky-dropdown-item>a[disabled]:active,.sky-dropdown-item>button[disabled],.sky-dropdown-item>button[disabled]:hover,.sky-dropdown-item>button[disabled]:focus-visible,.sky-dropdown-item>button[disabled]:active{box-shadow:var(--sky-override-dropdown-item-disabled-box-shadow, inset 0 0 0 var(--sky-border-width-action-disabled) var(--sky-color-border-action-tertiary-disabled));background-color:var(--sky-override-dropdown-item-disabled-color-background, var(--sky-color-background-action-tertiary-disabled));color:var(--sky-override-dropdown-item-disabled-color-text, var(--sky-color-text-deemphasized));cursor:default;font-size:var(--sky-override-dropdown-item-disabled-font-size, inherit);font-style:var(--sky-override-dropdown-item-disabled-font-style, inherit)}.sky-dropdown-item>a[disabled]:focus-visible,.sky-dropdown-item>a[disabled]:hover:focus-visible,.sky-dropdown-item>a[disabled]:focus-visible:focus-visible,.sky-dropdown-item>a[disabled]:active:focus-visible,.sky-dropdown-item>button[disabled]:focus-visible,.sky-dropdown-item>button[disabled]:hover:focus-visible,.sky-dropdown-item>button[disabled]:focus-visible:focus-visible,.sky-dropdown-item>button[disabled]:active:focus-visible{box-shadow:var(--sky-override-dropdown-item-disabled-box-shadow, inset 0 0 0 var(--sky-border-width-action-disabled) var(--sky-color-border-action-tertiary-disabled))}:host-context(.sky-theme-modern) .sky-dropdown-item>a,:host-context(.sky-theme-modern) .sky-dropdown-item>button{outline:none}.sky-theme-modern .sky-dropdown-item>a,.sky-theme-modern .sky-dropdown-item>button{outline:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }], propDecorators: { ariaRole: [{
                type: Input
            }] } });

/**
 * The type of message to send.
 * @internal
 */
var SkyDropdownMessageType;
(function (SkyDropdownMessageType) {
    /**
     * Opens the dropdown menu.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["Open"] = 0] = "Open";
    /**
     *  Closes the dropdown menu.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["Close"] = 1] = "Close";
    /**
     * Puts focus on the dropdown button.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["FocusTriggerButton"] = 2] = "FocusTriggerButton";
    /**
     * Puts focus on the next item in the dropdown menu.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["FocusNextItem"] = 3] = "FocusNextItem";
    /**
     * Puts focus on the previous item in the dropdown menu.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["FocusPreviousItem"] = 4] = "FocusPreviousItem";
    /**
     * Repositions the dropdown menu next to the dropdown button. This is useful for when the
     * dropdown menu's width and height change while it is open.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["Reposition"] = 5] = "Reposition";
    /**
     * Puts focus on the first item in the dropdown menu.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["FocusFirstItem"] = 6] = "FocusFirstItem";
    /**
     * Puts focus on the last item in the dropdown menu.
     */
    SkyDropdownMessageType[SkyDropdownMessageType["FocusLastItem"] = 7] = "FocusLastItem";
})(SkyDropdownMessageType || (SkyDropdownMessageType = {}));

function parseAffixHorizontalAlignment$1(alignment) {
    switch (alignment) {
        case 'center':
            return 'center';
        case 'left':
            return 'left';
        case 'right':
            return 'right';
        /* istanbul ignore next */
        default:
            throw `SkyAffixHorizontalAlignment does not have a matching value for '${alignment}'!`;
    }
}

/**
 * @internal
 */
class SkyDropdownTriggerDirective {
    constructor() {
        this.#resourcesSvc = inject(SkyLibResourcesService);
        this.nativeElement = inject(ElementRef).nativeElement;
        // Set by the dropdown component.
        this.isOpen = signal(undefined);
        this.menuId = signal(undefined);
        this.menuAriaRole = signal(undefined);
        this.label = signal(undefined);
        this.buttonType = signal(undefined);
        this.screenReaderLabelContextMenuId = signal(undefined);
        this.title = signal(undefined);
        this.disabled = signal(undefined);
        this.triggerClick = new Subject();
        this.triggerKeyDown = new Subject();
        this.triggerMouseEnter = new Subject();
        this.triggerMouseLeave = new Subject();
        this.#contentInfo = toSignal(inject(SkyContentInfoProvider, {
            optional: true,
        })?.getInfo() ?? of(undefined));
        this.#contextMenuLabel = toSignal(toObservable(this.#contentInfo).pipe(switchMap((contentInfo) => {
            const contentInfoDescriptor = contentInfo?.descriptor;
            if (contentInfoDescriptor) {
                if (contentInfoDescriptor.type === 'text') {
                    return this.#resourcesSvc.getString('skyux_dropdown_context_menu_with_content_descriptor_default_label', contentInfoDescriptor.value);
                }
                return of(undefined);
            }
            return this.#resourcesSvc.getString('skyux_dropdown_context_menu_default_label');
        })));
        this.ariaLabel = computed(() => {
            const label = this.label();
            if (label) {
                return label;
            }
            if (this.buttonType() === 'context-menu') {
                return this.#contextMenuLabel();
            }
            return undefined;
        });
        this.ariaLabelledby = computed(() => {
            return !this.label() &&
                this.buttonType() === 'context-menu' &&
                this.#contentInfo()?.descriptor?.type === 'elementId'
                ? this.screenReaderLabelContextMenuId() +
                    ' ' +
                    this.#contentInfo()?.descriptor?.value
                : undefined;
        });
    }
    #resourcesSvc;
    #contentInfo;
    #contextMenuLabel;
    ngOnDestroy() {
        this.triggerClick.complete();
        this.triggerKeyDown.complete();
        this.triggerMouseEnter.complete();
        this.triggerMouseLeave.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.7", type: SkyDropdownTriggerDirective, isStandalone: true, selector: "[skyDropdownTrigger]", host: { listeners: { "click": "triggerClick.next($event)", "keydown": "triggerKeyDown.next($event)", "mouseenter": "triggerMouseEnter.next($event)", "mouseleave": "triggerMouseLeave.next($event)" }, properties: { "attr.aria-expanded": "isOpen()", "attr.aria-controls": "isOpen() ? menuId() : null", "attr.aria-label": "ariaLabel()", "attr.aria-labelledby": "ariaLabelledby()", "attr.aria-haspopup": "menuAriaRole()", "attr.title": "title()", "attr.disabled": "disabled() || undefined" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[skyDropdownTrigger]',
                    standalone: true,
                    host: {
                        '[attr.aria-expanded]': 'isOpen()',
                        '[attr.aria-controls]': 'isOpen() ? menuId() : null',
                        '[attr.aria-label]': 'ariaLabel()',
                        '[attr.aria-labelledby]': 'ariaLabelledby()',
                        '[attr.aria-haspopup]': 'menuAriaRole()',
                        '[attr.title]': 'title()',
                        '[attr.disabled]': 'disabled() || undefined',
                        '(click)': 'triggerClick.next($event)',
                        '(keydown)': 'triggerKeyDown.next($event)',
                        '(mouseenter)': 'triggerMouseEnter.next($event)',
                        '(mouseleave)': 'triggerMouseLeave.next($event)',
                    },
                }]
        }] });

const DEFAULT_BUTTON_STYLE = 'default';
const DEFAULT_BUTTON_TYPE = 'select';
const DEFAULT_HORIZONTAL_ALIGNMENT = 'left';
const DEFAULT_TRIGGER_TYPE = 'click';
/**
 * Creates a dropdown menu that displays menu items that users may select.
 */
class SkyDropdownComponent {
    constructor() {
        this.#affixService = inject(SkyAffixService);
        this.#changeDetector = inject(ChangeDetectorRef);
        this.#environmentInjector = inject(EnvironmentInjector);
        this.#idSvc = inject(SkyIdService);
        this.#overlayService = inject(SkyOverlayService);
        this.#themeSvc = inject(SkyThemeService, { optional: true });
        this.#zIndex = inject(SKY_STACKING_CONTEXT, { optional: true })?.zIndex;
        this.#contentInfoProvider = inject(SkyContentInfoProvider, {
            optional: true,
        });
        this.contentInfoObs = this.#contentInfoProvider?.getInfo();
        /**
         * The observable that sends commands to the dropdown. The commands should respect
         * the [[SkyDropdownMessage]] type.
         * @internal
         */
        this.messageStream = new Subject();
        this.isMouseEnter = false;
        this.isVisible = false;
        this.screenReaderLabelContextMenuId = this.#idSvc.generateId();
        this.#ngUnsubscribe = new Subject();
        this.#triggerUnsubscribe = new Subject();
        this.#_buttonStyle = DEFAULT_BUTTON_STYLE;
        this.#_buttonType = DEFAULT_BUTTON_TYPE;
        this.#_disabled = false;
        this.#_horizontalAlignment = DEFAULT_HORIZONTAL_ALIGNMENT;
        this.#_isOpen = false;
        this.#_trigger = DEFAULT_TRIGGER_TYPE;
    }
    #affixService;
    #changeDetector;
    #environmentInjector;
    #idSvc;
    #overlayService;
    #themeSvc;
    #zIndex;
    #contentInfoProvider;
    /**
     * The background color for the dropdown button. Available values are `default`,
     * `primary`, and `link`. These values set the background color and hover behavior from the
     * [secondary and primary button classes](https://developer.blackbaud.com/skyux/components/button) respectively.
     * @default "default"
     */
    set buttonStyle(value) {
        this.#_buttonStyle = value ?? DEFAULT_BUTTON_STYLE;
    }
    get buttonStyle() {
        return this.#_buttonStyle;
    }
    /**
     * The type of button to render as the dropdown's trigger element. To display a button
     * with a caret, specify `'select'` and render the button text or icon in a
     * `sky-dropdown-button` element. To display a round button with an ellipsis, specify
     * `'context-menu'`.
     * @default "select"
     */
    set buttonType(value) {
        this.#_buttonType = value ?? DEFAULT_BUTTON_TYPE;
    }
    get buttonType() {
        return this.#_buttonType;
    }
    /**
     * Whether to disable the dropdown button.
     * @default false
     */
    set disabled(value) {
        this.#_disabled = value;
        this.#updateTrigger();
    }
    get disabled() {
        return this.#_disabled;
    }
    /**
     * The ARIA label for the dropdown. This sets the dropdown's `aria-label` attribute to provide a text equivalent for screen readers
     * [to support accessibility](https://developer.blackbaud.com/skyux/learn/accessibility). If multiple dropdowns with no label or the same label appear on the same page,
     * they must have unique ARIA labels that provide context, such as "Context menu for Robert Hernandez" or "Edit Robert Hernandez."
     * For more information about the `aria-label` attribute, see the [WAI-ARIA definition](https://www.w3.org/TR/wai-aria/#aria-label).
     */
    set label(value) {
        this.#_label = value;
        this.#updateTrigger();
    }
    get label() {
        return this.#_label;
    }
    /**
     * The horizontal alignment of the dropdown menu in relation to the dropdown button.
     * @default "left"
     */
    set horizontalAlignment(value) {
        this.#_horizontalAlignment = value ?? DEFAULT_HORIZONTAL_ALIGNMENT;
    }
    get horizontalAlignment() {
        return this.#_horizontalAlignment;
    }
    /**
     * The title to display in a tooltip when users hover the mouse over the dropdown button.
     */
    set title(value) {
        this.#_title = value;
        this.#updateTrigger();
    }
    get title() {
        return this.#_title;
    }
    /**
     * How users interact with the dropdown button to expose the dropdown menu.
     * We recommend the default `click` value because the `hover` value can pose
     * [accessibility](https://developer.blackbaud.com/skyux/learn/accessibility) issues
     * for users on touch devices such as phones and tablets.
     * @deprecated We recommend against using this property. If you choose to use the deprecated
     * `hover` value anyway, we recommend that you not use it in combination with the `title`
     * property.
     * @default "click"
     */
    set trigger(value) {
        this.#_trigger = value ?? DEFAULT_TRIGGER_TYPE;
    }
    get trigger() {
        return this.#_trigger;
    }
    set isOpen(value) {
        this.#_isOpen = value;
        this.#updateTrigger();
        this.#changeDetector.markForCheck();
    }
    get isOpen() {
        return this.#_isOpen;
    }
    set menuContainerElementRef(value) {
        if (value) {
            this.#destroyAffixer();
            this.#createAffixer(value);
        }
    }
    set menuId(value) {
        this.#_menuId = value;
        this.#updateTrigger();
    }
    get menuId() {
        return this.#_menuId;
    }
    set menuAriaRole(value) {
        this.#_menuAriaRole = value;
        this.#updateTrigger();
    }
    get menuAriaRole() {
        return this.#_menuAriaRole;
    }
    set triggerButton(value) {
        this.#_triggerButton = value;
        this.#addEventListeners();
        this.#updateTrigger();
    }
    get triggerButton() {
        return this.#_customTriggerButton ?? this.#_triggerButton;
    }
    set customTriggerButton(value) {
        this.#_customTriggerButton = value;
        this.#addEventListeners();
        this.#updateTrigger();
    }
    #affixer;
    #ngUnsubscribe;
    #triggerUnsubscribe;
    #overlay;
    #positionTimeout;
    #_buttonStyle;
    #_buttonType;
    #_customTriggerButton;
    #_disabled;
    #_horizontalAlignment;
    #_isOpen;
    #_label;
    #_menuAriaRole;
    #_menuId;
    #_title;
    #_trigger;
    #_triggerButton;
    ngOnInit() {
        this.messageStream
            ?.pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((message) => {
            this.#handleIncomingMessages(message);
        });
        // Load proper icons on theme change.
        this.#themeSvc?.settingsChange
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            this.#changeDetector.markForCheck();
        });
    }
    ngOnDestroy() {
        this.#destroyAffixer();
        this.#destroyOverlay();
        clearTimeout(this.#positionTimeout);
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
        this.#triggerUnsubscribe.next();
        this.#triggerUnsubscribe.complete();
    }
    #updateTrigger() {
        const triggerButton = this.triggerButton;
        if (triggerButton) {
            triggerButton.buttonType.set(this.buttonType);
            triggerButton.disabled.set(this.disabled);
            triggerButton.isOpen.set(this.isOpen);
            triggerButton.label.set(this.label);
            triggerButton.menuAriaRole.set(this.menuAriaRole);
            triggerButton.menuId.set(this.menuId);
            triggerButton.title.set(this.title);
            triggerButton.disabled.set(this.disabled);
            triggerButton.screenReaderLabelContextMenuId.set(this.screenReaderLabelContextMenuId);
        }
    }
    #addEventListeners() {
        this.#triggerUnsubscribe.next();
        this.#triggerUnsubscribe.complete();
        this.#triggerUnsubscribe = new Subject();
        const triggerButton = this.triggerButton;
        if (triggerButton) {
            triggerButton.triggerClick
                .pipe(takeUntil(this.#triggerUnsubscribe))
                .subscribe(() => {
                if (this.isOpen) {
                    this.#sendMessage(SkyDropdownMessageType.Close);
                }
                else {
                    this.#sendMessage(SkyDropdownMessageType.Open);
                    // Wait for dropdown to open, then set focus on first item.
                    setTimeout(() => {
                        this.#sendMessage(SkyDropdownMessageType.FocusFirstItem);
                    });
                }
            });
            triggerButton.triggerKeyDown
                .pipe(takeUntil(this.#triggerUnsubscribe))
                .subscribe((event) => {
                const key = event.key.toLowerCase();
                switch (key) {
                    case 'escape':
                        /*istanbul ignore else*/
                        this.#handleTriggerEscape(event);
                        break;
                    case 'tab':
                        this.#handleTriggerTab();
                        break;
                    case 'arrowup':
                    case 'up':
                        this.#handleTriggerUp(event);
                        break;
                    case 'enter':
                    case 'arrowdown':
                    case 'down':
                    case ' ': // Spacebar.
                        this.#handleTriggerDown(event);
                        break;
                }
            });
            triggerButton.triggerMouseEnter
                .pipe(takeUntil(this.#triggerUnsubscribe))
                .subscribe(() => {
                this.isMouseEnter = true;
                if (this.trigger === 'hover') {
                    this.#sendMessage(SkyDropdownMessageType.Open);
                }
            });
            triggerButton.triggerMouseLeave
                .pipe(takeUntil(this.#triggerUnsubscribe))
                .subscribe(() => {
                this.isMouseEnter = false;
                if (this.trigger === 'hover') {
                    // Allow the dropdown menu to set isMouseEnter before checking if the close action
                    // should be taken.
                    setTimeout(() => {
                        if (!this.isMouseEnter) {
                            this.#sendMessage(SkyDropdownMessageType.Close);
                        }
                    });
                }
            });
        }
    }
    #handleTriggerEscape(event) {
        if (this.isOpen) {
            this.#sendMessage(SkyDropdownMessageType.Close);
            this.#sendMessage(SkyDropdownMessageType.FocusTriggerButton);
            event.stopPropagation();
        }
    }
    #handleTriggerTab() {
        if (this.isOpen) {
            this.#sendMessage(SkyDropdownMessageType.Close);
        }
    }
    #handleTriggerUp(event) {
        if (!this.isOpen) {
            this.#sendMessage(SkyDropdownMessageType.Open);
            this.#sendMessage(SkyDropdownMessageType.FocusLastItem);
            event.preventDefault();
            event.stopPropagation();
        }
    }
    #handleTriggerDown(event) {
        /*istanbul ignore else*/
        if (!this.isOpen) {
            this.#sendMessage(SkyDropdownMessageType.Open);
            this.#sendMessage(SkyDropdownMessageType.FocusFirstItem);
            event.preventDefault();
            event.stopPropagation();
        }
    }
    #createOverlay() {
        /* istanbul ignore next */
        if (this.#overlay) {
            return;
        }
        this.isVisible = false;
        if (this.menuContainerTemplateRef) {
            const overlay = this.#overlayService.create({
                enableScroll: true,
                enablePointerEvents: true,
                environmentInjector: this.#environmentInjector,
            });
            if (this.#zIndex) {
                this.#zIndex
                    .pipe(takeUntil(this.#ngUnsubscribe))
                    .subscribe((zIndex) => {
                    overlay.componentRef.instance.zIndex = zIndex.toString(10);
                });
            }
            overlay.attachTemplate(this.menuContainerTemplateRef);
            overlay.backdropClick
                .pipe(takeUntil(this.#ngUnsubscribe))
                .subscribe(() => {
                this.#sendMessage(SkyDropdownMessageType.Close);
            });
            this.#overlay = overlay;
        }
        this.#changeDetector.markForCheck();
    }
    #destroyAffixer() {
        /*istanbul ignore else*/
        if (this.#affixer) {
            this.#affixer.destroy();
            this.#affixer = undefined;
        }
    }
    #destroyOverlay() {
        /*istanbul ignore else*/
        if (this.#overlay) {
            this.#overlayService.close(this.#overlay);
            this.#overlay = undefined;
        }
    }
    #createAffixer(menuContainerElementRef) {
        const affixer = (this.#affixer = this.#affixService.createAffixer(menuContainerElementRef));
        affixer.placementChange
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((change) => {
            this.isVisible = change.placement !== null;
            this.#changeDetector.markForCheck();
        });
        affixer.affixTo(this.triggerButton?.nativeElement, {
            autoFitContext: SkyAffixAutoFitContext.Viewport,
            enableAutoFit: true,
            horizontalAlignment: parseAffixHorizontalAlignment$1(this.horizontalAlignment),
            isSticky: true,
            placement: 'below',
        });
        this.isVisible = true;
        this.#changeDetector.markForCheck();
    }
    #handleIncomingMessages(message) {
        if (!this.disabled) {
            switch (message.type) {
                case SkyDropdownMessageType.Open:
                    if (!this.isOpen) {
                        this.isOpen = true;
                        this.#createOverlay();
                    }
                    break;
                case SkyDropdownMessageType.Close:
                    this.isOpen = false;
                    this.#destroyOverlay();
                    break;
                case SkyDropdownMessageType.Reposition:
                    // Only reposition the dropdown if it is already open.
                    /* istanbul ignore else */
                    if (this.isOpen && this.#affixer) {
                        this.#affixer.reaffix();
                    }
                    break;
                case SkyDropdownMessageType.FocusTriggerButton:
                    this.triggerButton?.nativeElement.focus();
                    break;
            }
        }
    }
    #sendMessage(type) {
        this.messageStream?.next({ type });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.7", type: SkyDropdownComponent, isStandalone: false, selector: "sky-dropdown", inputs: { buttonStyle: "buttonStyle", buttonType: "buttonType", disabled: "disabled", label: "label", horizontalAlignment: "horizontalAlignment", messageStream: "messageStream", title: "title", trigger: "trigger" }, queries: [{ propertyName: "customTriggerButton", first: true, predicate: SkyDropdownTriggerDirective, descendants: true }], viewQueries: [{ propertyName: "menuContainerElementRef", first: true, predicate: ["menuContainerElementRef"], descendants: true, read: ElementRef }, { propertyName: "menuContainerTemplateRef", first: true, predicate: ["menuContainerTemplateRef"], descendants: true, read: TemplateRef, static: true }, { propertyName: "triggerButton", first: true, predicate: ["triggerButton"], descendants: true, read: SkyDropdownTriggerDirective }], ngImport: i0, template: "<div class=\"sky-dropdown\">\n  <ng-content select=\"[skyDropdownTrigger]\">\n    <button\n      #triggerButton\n      class=\"sky-btn sky-dropdown-button\"\n      skyDropdownTrigger\n      type=\"button\"\n      [ngClass]=\"[\n        'sky-dropdown-button-type-' + buttonType,\n        'sky-btn-' + buttonStyle\n      ]\"\n    >\n      @switch (buttonType) {\n        @case ('context-menu') {\n          <sky-icon *skyThemeIf=\"'modern'\" iconName=\"more-actions\" />\n          <sky-icon *skyThemeIf=\"'default'\" iconName=\"more-actions\" />\n        }\n        @default {\n          <div class=\"sky-dropdown-button-container\">\n            <div class=\"sky-dropdown-button-content-container\">\n              <ng-content select=\"sky-dropdown-button\" />\n            </div>\n            <div class=\"sky-dropdown-button-icon-container\">\n              <sky-icon\n                class=\"sky-dropdown-caret\"\n                iconName=\"chevron-down\"\n                iconSize=\"s\"\n              />\n            </div>\n          </div>\n        }\n      }\n    </button>\n  </ng-content>\n</div>\n\n<ng-template #menuContainerTemplateRef>\n  <div\n    #menuContainerElementRef\n    class=\"sky-dropdown-menu-container\"\n    [class.hidden]=\"!isVisible\"\n  >\n    <ng-content select=\"sky-dropdown-menu\" />\n  </div>\n</ng-template>\n<span\n  skyScreenReaderLabel\n  [createLabel]=\"\n    buttonType === 'context-menu' &&\n    (contentInfoObs | async)?.descriptor?.type === 'elementId'\n  \"\n  [attr.id]=\"screenReaderLabelContextMenuId\"\n>\n  {{\n    'skyux_dropdown_context_menu_with_content_descriptor_el_default_label'\n      | skyLibResources\n  }}\n</span>\n", styles: [".sky-dropdown:not(.sky-theme-modern *){--sky-override-caret-margin-left: 10px;--sky-override-context-menu-border-radius: 50%;--sky-override-context-menu-font-size: 15px;--sky-override-context-menu-line-height: 1.428571429;--sky-override-context-menu-padding: 3px;--sky-override-context-menu-height-width: 30px}.sky-dropdown-button-type-tab:not(.sky-theme-modern *){--sky-override-tab-border-bottom: none;--sky-override-tab-button-radius: 4px;--sky-override-tab-dropdown-color: var(--sky-text-color-on-dark);--sky-override-tab-font-size: 15px;--sky-override-tab-font-weight: 600;--sky-override-tab-line-height: 1.8;--sky-override-tab-padding: 8px 16px;--sky-override-tab-selected-background-color: var( --sky-background-color-primary-dark )}:host-context(.sky-theme-modern:not(.sky-theme-brand-base)) .sky-dropdown{--sky-override-context-menu-font-size: var(--sky-font-size-body-m);--sky-override-context-menu-line-height: calc(20 / 14);--sky-override-context-menu-padding: var(--modern-size-3) var(--modern-size-8)}:host-context(.sky-theme-modern:not(.sky-theme-brand-base)) .sky-dropdown-button-type-tab{--sky-override-tab-button-radius: 0;--sky-override-tab-line-height: 1.8;--sky-override-tab-selected-background-color: var(--modern-color-transparent);--sky-override-tab-selected-border-bottom-size: var(--modern-size-3)}.sky-dropdown .sky-dropdown-button-type-tab{background-color:var(--sky-override-tab-selected-background-color, var(--sky-color-background-selected-soft));border:none;box-shadow:none;border-radius:var(--sky-override-tab-button-radius, var(--sky-border-radius-s)) var(--sky-override-tab-button-radius, var(--sky-border-radius-s)) 0 0;color:var(--sky-override-tab-dropdown-color, var(--sky-color-text-default));border-bottom:var(--sky-override-tab-border-bottom, var(--sky-override-tab-selected-border-bottom-size, var(--sky-border-width-selected-l)) var(--sky-border-style-accent) var(--sky-color-border-selected));cursor:pointer;display:inline-block;font-size:var(--sky-override-tab-font-size, var(--sky-font-size-body-m));font-weight:var(--sky-override-tab-font-weight, var(--sky-font-weight-body-m));line-height:var(--sky-override-tab-line-height, var(--sky-font-line_height-body-m));padding:var(--sky-override-tab-padding, var(--sky-space-inset-pillarbox-2_3-top-m) var(--sky-space-inset-pillarbox-2_3-right-m) calc(var(--sky-space-inset-pillarbox-2_3-bottom-m) - var(--sky-override-tab-selected-border-bottom-size, var(--sky-border-width-selected-l))) var(--sky-space-inset-pillarbox-2_3-left-m));max-width:100%;text-align:left}.sky-dropdown-button-type-context-menu{border-radius:var(--sky-override-context-menu-border-radius, var(--sky-border-radius-s));padding:var(--sky-override-context-menu-padding, var(--sky-space-inset-balanced-xs));font-size:var(--sky-override-context-menu-font-size, var(--sky-font-size-body-l));line-height:var(--sky-override-context-menu-line-height, 1);height:var(--sky-override-context-menu-height-width);width:var(--sky-override-context-menu-height-width)}:host-context(.sky-toolbar-container) .sky-dropdown-button.sky-btn-link{color:#212327}.sky-dropdown-caret{margin-left:var(--sky-override-caret-margin-left, var(--sky-space-gap-icon-m))}.sky-dropdown-button-container{display:flex}.sky-dropdown-button-content-container{flex-shrink:1;overflow:hidden;text-overflow:ellipsis}.sky-dropdown-button-icon-container{flex-grow:1}.sky-dropdown-menu-container{position:fixed}.hidden{visibility:hidden}:host-context(.sky-theme-modern) .sky-dropdown-button-type-tab:focus-visible{outline:none}:host-context(.sky-theme-modern) .sky-dropdown-button-type-tab:focus-visible:not(:active){outline:solid var(--sky-border-width-selected-m) var(--sky-color-border-selected);outline-offset:calc(var(--sky-border-width-selected-m) * -1);box-shadow:var(--sky-elevation-focus)}:host-context(.sky-theme-modern) .sky-dropdown-button-type-context-menu{background-color:var(--sky-color-background-action-tertiary-base)}:host-context(.sky-theme-modern) .sky-dropdown-button-type-context-menu:not(:hover):not(:focus-visible){box-shadow:inset 0 0 0 var(--sky-border-width-action-base) var(--sky-color-border-action-tertiary-base)}.sky-theme-modern .sky-dropdown-button-type-tab:focus-visible{outline:none}.sky-theme-modern .sky-dropdown-button-type-tab:focus-visible:not(:active){outline:solid var(--sky-border-width-selected-m) var(--sky-color-border-selected);outline-offset:calc(var(--sky-border-width-selected-m) * -1);box-shadow:var(--sky-elevation-focus)}.sky-theme-modern .sky-dropdown-button-type-context-menu{background-color:var(--sky-color-background-action-tertiary-base)}.sky-theme-modern .sky-dropdown-button-type-context-menu:not(:hover):not(:focus-visible){box-shadow:inset 0 0 0 var(--sky-border-width-action-base) var(--sky-color-border-action-tertiary-base)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: SkyDropdownTriggerDirective, selector: "[skyDropdownTrigger]" }, { kind: "component", type: i3.λ1, selector: "sky-icon", inputs: ["icon", "iconName", "iconType", "size", "fixedWidth", "variant", "iconSize"] }, { kind: "directive", type: i1$1.SkyScreenReaderLabelDirective, selector: "[skyScreenReaderLabel]", inputs: ["createLabel"] }, { kind: "directive", type: i3$1.λ3, selector: "[skyThemeIf]", inputs: ["skyThemeIf"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i6.SkyLibResourcesPipe, name: "skyLibResources" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div class=\"sky-dropdown\">\n  <ng-content select=\"[skyDropdownTrigger]\">\n    <button\n      #triggerButton\n      class=\"sky-btn sky-dropdown-button\"\n      skyDropdownTrigger\n      type=\"button\"\n      [ngClass]=\"[\n        'sky-dropdown-button-type-' + buttonType,\n        'sky-btn-' + buttonStyle\n      ]\"\n    >\n      @switch (buttonType) {\n        @case ('context-menu') {\n          <sky-icon *skyThemeIf=\"'modern'\" iconName=\"more-actions\" />\n          <sky-icon *skyThemeIf=\"'default'\" iconName=\"more-actions\" />\n        }\n        @default {\n          <div class=\"sky-dropdown-button-container\">\n            <div class=\"sky-dropdown-button-content-container\">\n              <ng-content select=\"sky-dropdown-button\" />\n            </div>\n            <div class=\"sky-dropdown-button-icon-container\">\n              <sky-icon\n                class=\"sky-dropdown-caret\"\n                iconName=\"chevron-down\"\n                iconSize=\"s\"\n              />\n            </div>\n          </div>\n        }\n      }\n    </button>\n  </ng-content>\n</div>\n\n<ng-template #menuContainerTemplateRef>\n  <div\n    #menuContainerElementRef\n    class=\"sky-dropdown-menu-container\"\n    [class.hidden]=\"!isVisible\"\n  >\n    <ng-content select=\"sky-dropdown-menu\" />\n  </div>\n</ng-template>\n<span\n  skyScreenReaderLabel\n  [createLabel]=\"\n    buttonType === 'context-menu' &&\n    (contentInfoObs | async)?.descriptor?.type === 'elementId'\n  \"\n  [attr.id]=\"screenReaderLabelContextMenuId\"\n>\n  {{\n    'skyux_dropdown_context_menu_with_content_descriptor_el_default_label'\n      | skyLibResources\n  }}\n</span>\n", styles: [".sky-dropdown:not(.sky-theme-modern *){--sky-override-caret-margin-left: 10px;--sky-override-context-menu-border-radius: 50%;--sky-override-context-menu-font-size: 15px;--sky-override-context-menu-line-height: 1.428571429;--sky-override-context-menu-padding: 3px;--sky-override-context-menu-height-width: 30px}.sky-dropdown-button-type-tab:not(.sky-theme-modern *){--sky-override-tab-border-bottom: none;--sky-override-tab-button-radius: 4px;--sky-override-tab-dropdown-color: var(--sky-text-color-on-dark);--sky-override-tab-font-size: 15px;--sky-override-tab-font-weight: 600;--sky-override-tab-line-height: 1.8;--sky-override-tab-padding: 8px 16px;--sky-override-tab-selected-background-color: var( --sky-background-color-primary-dark )}:host-context(.sky-theme-modern:not(.sky-theme-brand-base)) .sky-dropdown{--sky-override-context-menu-font-size: var(--sky-font-size-body-m);--sky-override-context-menu-line-height: calc(20 / 14);--sky-override-context-menu-padding: var(--modern-size-3) var(--modern-size-8)}:host-context(.sky-theme-modern:not(.sky-theme-brand-base)) .sky-dropdown-button-type-tab{--sky-override-tab-button-radius: 0;--sky-override-tab-line-height: 1.8;--sky-override-tab-selected-background-color: var(--modern-color-transparent);--sky-override-tab-selected-border-bottom-size: var(--modern-size-3)}.sky-dropdown .sky-dropdown-button-type-tab{background-color:var(--sky-override-tab-selected-background-color, var(--sky-color-background-selected-soft));border:none;box-shadow:none;border-radius:var(--sky-override-tab-button-radius, var(--sky-border-radius-s)) var(--sky-override-tab-button-radius, var(--sky-border-radius-s)) 0 0;color:var(--sky-override-tab-dropdown-color, var(--sky-color-text-default));border-bottom:var(--sky-override-tab-border-bottom, var(--sky-override-tab-selected-border-bottom-size, var(--sky-border-width-selected-l)) var(--sky-border-style-accent) var(--sky-color-border-selected));cursor:pointer;display:inline-block;font-size:var(--sky-override-tab-font-size, var(--sky-font-size-body-m));font-weight:var(--sky-override-tab-font-weight, var(--sky-font-weight-body-m));line-height:var(--sky-override-tab-line-height, var(--sky-font-line_height-body-m));padding:var(--sky-override-tab-padding, var(--sky-space-inset-pillarbox-2_3-top-m) var(--sky-space-inset-pillarbox-2_3-right-m) calc(var(--sky-space-inset-pillarbox-2_3-bottom-m) - var(--sky-override-tab-selected-border-bottom-size, var(--sky-border-width-selected-l))) var(--sky-space-inset-pillarbox-2_3-left-m));max-width:100%;text-align:left}.sky-dropdown-button-type-context-menu{border-radius:var(--sky-override-context-menu-border-radius, var(--sky-border-radius-s));padding:var(--sky-override-context-menu-padding, var(--sky-space-inset-balanced-xs));font-size:var(--sky-override-context-menu-font-size, var(--sky-font-size-body-l));line-height:var(--sky-override-context-menu-line-height, 1);height:var(--sky-override-context-menu-height-width);width:var(--sky-override-context-menu-height-width)}:host-context(.sky-toolbar-container) .sky-dropdown-button.sky-btn-link{color:#212327}.sky-dropdown-caret{margin-left:var(--sky-override-caret-margin-left, var(--sky-space-gap-icon-m))}.sky-dropdown-button-container{display:flex}.sky-dropdown-button-content-container{flex-shrink:1;overflow:hidden;text-overflow:ellipsis}.sky-dropdown-button-icon-container{flex-grow:1}.sky-dropdown-menu-container{position:fixed}.hidden{visibility:hidden}:host-context(.sky-theme-modern) .sky-dropdown-button-type-tab:focus-visible{outline:none}:host-context(.sky-theme-modern) .sky-dropdown-button-type-tab:focus-visible:not(:active){outline:solid var(--sky-border-width-selected-m) var(--sky-color-border-selected);outline-offset:calc(var(--sky-border-width-selected-m) * -1);box-shadow:var(--sky-elevation-focus)}:host-context(.sky-theme-modern) .sky-dropdown-button-type-context-menu{background-color:var(--sky-color-background-action-tertiary-base)}:host-context(.sky-theme-modern) .sky-dropdown-button-type-context-menu:not(:hover):not(:focus-visible){box-shadow:inset 0 0 0 var(--sky-border-width-action-base) var(--sky-color-border-action-tertiary-base)}.sky-theme-modern .sky-dropdown-button-type-tab:focus-visible{outline:none}.sky-theme-modern .sky-dropdown-button-type-tab:focus-visible:not(:active){outline:solid var(--sky-border-width-selected-m) var(--sky-color-border-selected);outline-offset:calc(var(--sky-border-width-selected-m) * -1);box-shadow:var(--sky-elevation-focus)}.sky-theme-modern .sky-dropdown-button-type-context-menu{background-color:var(--sky-color-background-action-tertiary-base)}.sky-theme-modern .sky-dropdown-button-type-context-menu:not(:hover):not(:focus-visible){box-shadow:inset 0 0 0 var(--sky-border-width-action-base) var(--sky-color-border-action-tertiary-base)}\n"] }]
        }], propDecorators: { buttonStyle: [{
                type: Input
            }], buttonType: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], horizontalAlignment: [{
                type: Input
            }], messageStream: [{
                type: Input
            }], title: [{
                type: Input
            }], trigger: [{
                type: Input
            }], menuContainerElementRef: [{
                type: ViewChild,
                args: ['menuContainerElementRef', {
                        read: ElementRef,
                    }]
            }], menuContainerTemplateRef: [{
                type: ViewChild,
                args: ['menuContainerTemplateRef', {
                        read: TemplateRef,
                        static: true,
                    }]
            }], triggerButton: [{
                type: ViewChild,
                args: ['triggerButton', {
                        read: SkyDropdownTriggerDirective,
                    }]
            }], customTriggerButton: [{
                type: ContentChild,
                args: [SkyDropdownTriggerDirective]
            }] } });

let nextId = 0;
/**
 * Creates a menu that contains dropdown menu items.
 *
 */
class SkyDropdownMenuComponent {
    /**
     * The ARIA role for the dropdown menu
     * [to support accessibility](https://developer.blackbaud.com/skyux/learn/accessibility)
     * by indicating how the dropdown menu functions and what it controls. The dropdown button
     * inherits this value to set its `aria-haspopup` property. For information
     * about how an ARIA role indicates what an item represents on a web page, see the
     * [WAI-ARIA roles model](https://www.w3.org/WAI/PF/aria/#roles).
     * @default "menu"
     */
    set ariaRole(value) {
        this.#_ariaRole = value ?? 'menu';
    }
    get ariaRole() {
        return this.#_ariaRole;
    }
    /**
     * Whether to use the browser's native focus function when users navigate through menu
     * items with the keyboard. To disable the native focus function, set this property to `false`.
     * For example, to let users interact with the dropdown menu but keep the keyboard focus on a
     * different element, set this property to `false`.
     * @default true
     * @internal
     */
    set useNativeFocus(value) {
        this.#_useNativeFocus = value ?? true;
    }
    get useNativeFocus() {
        return this.#_useNativeFocus;
    }
    set menuIndex(value) {
        if (value < 0) {
            value = this.menuItems.length - 1;
        }
        if (value >= this.menuItems.length) {
            value = 0;
        }
        this.#_menuIndex = value;
    }
    get menuIndex() {
        return this.#_menuIndex;
    }
    #ngUnsubscribe;
    #_ariaRole;
    #_menuIndex;
    #_useNativeFocus;
    #changeDetector;
    #elementRef;
    #dropdownComponent;
    constructor(changeDetector, elementRef, dropdownComponent) {
        /**
         * Fires when the dropdown menu's active index or selected item changes. This event provides an
         * observable to emit changes, and the response is of
         * the SkyDropdownMenuChange type.
         * @internal
         */
        this.menuChanges = new EventEmitter();
        this.dropdownMenuId = `sky-dropdown-menu-${++nextId}`;
        this.#ngUnsubscribe = new Subject();
        this.#_ariaRole = 'menu';
        this.#_menuIndex = 0;
        this.#_useNativeFocus = true;
        this.#changeDetector = changeDetector;
        this.#elementRef = elementRef;
        this.#dropdownComponent = dropdownComponent;
    }
    ngAfterContentInit() {
        /* istanbul ignore else */
        if (this.#dropdownComponent) {
            this.#dropdownComponent.menuId = this.dropdownMenuId;
            this.#dropdownComponent.menuAriaRole = this.ariaRole;
            this.#dropdownComponent.messageStream
                ?.pipe(takeUntil(this.#ngUnsubscribe))
                .subscribe((message) => {
                switch (message.type) {
                    case SkyDropdownMessageType.Open:
                    case SkyDropdownMessageType.Close:
                        this.reset();
                        break;
                    case SkyDropdownMessageType.FocusFirstItem:
                        this.focusFirstItem();
                        break;
                    case SkyDropdownMessageType.FocusNextItem:
                        this.focusNextItem();
                        break;
                    case SkyDropdownMessageType.FocusPreviousItem:
                        this.focusPreviousItem();
                        break;
                    case SkyDropdownMessageType.FocusLastItem:
                        this.focusLastItem();
                        break;
                }
            });
            this.menuChanges
                .pipe(takeUntil(this.#ngUnsubscribe))
                .subscribe((change) => {
                // Close the dropdown when a menu item is selected.
                if (change.selectedItem) {
                    this.#sendMessage(SkyDropdownMessageType.Close);
                    this.#sendMessage(SkyDropdownMessageType.FocusTriggerButton);
                }
                if (change.items) {
                    // Update the popover style and position whenever the number of items changes.
                    this.#sendMessage(SkyDropdownMessageType.Reposition);
                }
            });
        }
        // Reset dropdown whenever the menu items change.
        this.menuItems.changes
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((items) => {
            this.reset();
            this.menuChanges.emit({
                items: items.toArray(),
            });
        });
        this.#addEventListeners();
    }
    ngOnDestroy() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
    }
    focusFirstItem() {
        if (!this.#hasFocusableItems()) {
            return;
        }
        this.menuIndex = 0;
        const firstItem = this.#getItemByIndex(this.menuIndex);
        if (firstItem && firstItem.isFocusable()) {
            this.#focusItem(firstItem);
        }
        else {
            this.focusNextItem();
        }
    }
    focusLastItem() {
        if (!this.#hasFocusableItems()) {
            return;
        }
        this.menuIndex = this.menuItems.length - 1;
        const lastItem = this.#getItemByIndex(this.menuIndex);
        if (lastItem && lastItem.isFocusable()) {
            this.#focusItem(lastItem);
        }
        else {
            this.focusPreviousItem();
        }
    }
    focusPreviousItem() {
        if (!this.#hasFocusableItems()) {
            return;
        }
        this.menuIndex--;
        const previousItem = this.#getItemByIndex(this.menuIndex);
        if (previousItem && previousItem.isFocusable()) {
            this.#focusItem(previousItem);
        }
        else {
            this.focusPreviousItem();
        }
    }
    focusNextItem() {
        if (!this.#hasFocusableItems()) {
            return;
        }
        this.menuIndex++;
        const nextItem = this.#getItemByIndex(this.menuIndex);
        if (nextItem && nextItem.isFocusable()) {
            this.#focusItem(nextItem);
        }
        else {
            this.focusNextItem();
        }
    }
    reset() {
        this.#_menuIndex = -1;
        this.#resetItemsActiveState();
        this.#changeDetector.markForCheck();
    }
    #resetItemsActiveState() {
        this.menuItems.forEach((item) => {
            item.resetState();
        });
    }
    #focusItem(item) {
        this.#resetItemsActiveState();
        item.focusElement(this.useNativeFocus);
        this.menuChanges.emit({
            activeIndex: this.menuIndex,
        });
    }
    #getItemByIndex(index) {
        return this.menuItems.find((_, i) => i === index);
    }
    #selectItemByEventTarget(target) {
        const selectedItem = this.menuItems.find((item, i) => {
            const found = item.elementRef.nativeElement.contains(target);
            if (found) {
                this.menuIndex = i;
                this.menuChanges.next({
                    activeIndex: this.menuIndex,
                });
            }
            return found;
        });
        /* istanbul ignore else */
        if (selectedItem) {
            this.menuChanges.next({
                selectedItem,
            });
        }
    }
    #sendMessage(type) {
        this.#dropdownComponent?.messageStream?.next({ type });
    }
    #addEventListeners() {
        const dropdownMenuElement = this.#elementRef.nativeElement;
        fromEvent(dropdownMenuElement, 'click')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((event) => {
            this.#selectItemByEventTarget(event.target);
        });
        fromEvent(dropdownMenuElement, 'keydown')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((event) => {
            const key = event.key.toLowerCase();
            switch (key) {
                case 'escape':
                    this.#sendMessage(SkyDropdownMessageType.Close);
                    this.#sendMessage(SkyDropdownMessageType.FocusTriggerButton);
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case 'arrowdown':
                case 'down':
                    this.focusNextItem();
                    event.preventDefault();
                    break;
                case 'arrowup':
                case 'up':
                    this.focusPreviousItem();
                    event.preventDefault();
                    break;
                case 'tab':
                    this.#sendMessage(SkyDropdownMessageType.Close);
                    this.#sendMessage(SkyDropdownMessageType.FocusTriggerButton);
                    break;
            }
        });
        fromEvent(dropdownMenuElement, 'mouseenter')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            /* istanbul ignore else */
            if (this.#dropdownComponent) {
                this.#dropdownComponent.isMouseEnter = true;
            }
        });
        fromEvent(dropdownMenuElement, 'mouseleave')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            /* istanbul ignore else */
            if (this.#dropdownComponent) {
                this.#dropdownComponent.isMouseEnter = false;
                // Allow the dropdown component to set isMouseEnter before checking if the close action
                // should be taken.
                setTimeout(() => {
                    if (this.#dropdownComponent &&
                        this.#dropdownComponent.trigger === 'hover' &&
                        this.#dropdownComponent.isMouseEnter === false) {
                        this.#sendMessage(SkyDropdownMessageType.Close);
                    }
                });
            }
        });
    }
    #hasFocusableItems() {
        const found = this.menuItems.find((item) => item.isFocusable());
        return found !== undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownMenuComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: SkyDropdownComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.7", type: SkyDropdownMenuComponent, isStandalone: false, selector: "sky-dropdown-menu", inputs: { ariaLabelledBy: "ariaLabelledBy", ariaRole: "ariaRole", useNativeFocus: "useNativeFocus" }, outputs: { menuChanges: "menuChanges" }, queries: [{ propertyName: "menuItems", predicate: SkyDropdownItemComponent, descendants: true }], ngImport: i0, template: "<div\n  class=\"sky-dropdown-menu sky-shadow sky-elevation-4\"\n  [attr.aria-labelledby]=\"ariaLabelledBy\"\n  [attr.role]=\"ariaRole\"\n  [id]=\"dropdownMenuId\"\n>\n  <ng-content />\n</div>\n", styles: [".sky-dropdown-menu:not(.sky-theme-modern *){--sky-override-dropdown-menu-border-radius: 0px;--sky-override-dropdown-menu-color-background: #fff;--sky-override-dropdown-menu-padding: 0}.sky-dropdown-menu{overflow-y:auto;overflow-x:hidden;min-height:35px;max-height:calc(100vh - min(50px,5vh));display:flex;flex-direction:column;background-color:var(--sky-override-dropdown-menu-color-background, var(--sky-color-background-container-menu));border-radius:var(--sky-override-dropdown-menu-border-radius, var(--sky-border-radius-s));padding:var(--sky-override-dropdown-menu-padding, var(--sky-space-inset-vertical-top-s) var(--sky-space-inset-vertical-left-s) var(--sky-space-inset-vertical-bottom-s) var(--sky-space-inset-vertical-right-s))}.sky-dropdown-menu button{overflow:hidden;text-overflow:ellipsis}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-dropdown-menu', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, standalone: false, template: "<div\n  class=\"sky-dropdown-menu sky-shadow sky-elevation-4\"\n  [attr.aria-labelledby]=\"ariaLabelledBy\"\n  [attr.role]=\"ariaRole\"\n  [id]=\"dropdownMenuId\"\n>\n  <ng-content />\n</div>\n", styles: [".sky-dropdown-menu:not(.sky-theme-modern *){--sky-override-dropdown-menu-border-radius: 0px;--sky-override-dropdown-menu-color-background: #fff;--sky-override-dropdown-menu-padding: 0}.sky-dropdown-menu{overflow-y:auto;overflow-x:hidden;min-height:35px;max-height:calc(100vh - min(50px,5vh));display:flex;flex-direction:column;background-color:var(--sky-override-dropdown-menu-color-background, var(--sky-color-background-container-menu));border-radius:var(--sky-override-dropdown-menu-border-radius, var(--sky-border-radius-s));padding:var(--sky-override-dropdown-menu-padding, var(--sky-space-inset-vertical-top-s) var(--sky-space-inset-vertical-left-s) var(--sky-space-inset-vertical-bottom-s) var(--sky-space-inset-vertical-right-s))}.sky-dropdown-menu button{overflow:hidden;text-overflow:ellipsis}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: SkyDropdownComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { ariaLabelledBy: [{
                type: Input
            }], ariaRole: [{
                type: Input
            }], useNativeFocus: [{
                type: Input
            }], menuChanges: [{
                type: Output
            }], menuItems: [{
                type: ContentChildren,
                args: [SkyDropdownItemComponent, { descendants: true }]
            }] } });

class SkyDropdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownModule, declarations: [SkyDropdownButtonComponent,
            SkyDropdownComponent,
            SkyDropdownItemComponent,
            SkyDropdownMenuComponent], imports: [CommonModule,
            SkyAffixModule,
            SkyDropdownTriggerDirective,
            SkyIconModule,
            SkyIdModule,
            SkyPopoversResourcesModule,
            SkyScreenReaderLabelDirective,
            SkyThemeModule], exports: [SkyDropdownButtonComponent,
            SkyDropdownComponent,
            SkyDropdownItemComponent,
            SkyDropdownMenuComponent,
            SkyDropdownTriggerDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownModule, imports: [CommonModule,
            SkyAffixModule,
            SkyIconModule,
            SkyIdModule,
            SkyPopoversResourcesModule,
            SkyThemeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SkyDropdownButtonComponent,
                        SkyDropdownComponent,
                        SkyDropdownItemComponent,
                        SkyDropdownMenuComponent,
                    ],
                    imports: [
                        CommonModule,
                        SkyAffixModule,
                        SkyDropdownTriggerDirective,
                        SkyIconModule,
                        SkyIdModule,
                        SkyPopoversResourcesModule,
                        SkyScreenReaderLabelDirective,
                        SkyThemeModule,
                    ],
                    exports: [
                        SkyDropdownButtonComponent,
                        SkyDropdownComponent,
                        SkyDropdownItemComponent,
                        SkyDropdownMenuComponent,
                        SkyDropdownTriggerDirective,
                    ],
                }]
        }] });

/**
 * @internal
 */
const skyPopoverAnimation = trigger('skyPopoverAnimation', [
    state('void', style({
        opacity: 0,
    })),
    state('open', style({
        opacity: 1,
    })),
    state('closed', style({
        opacity: 0,
    })),
    transition('void => *', [animate('250ms')]),
    transition('open => closed', [animate('150ms')]),
    transition('closed => open', [animate('150ms')]),
]);

function parseAffixPlacement(placement) {
    switch (placement) {
        case 'above':
            return 'above';
        case 'below':
            return 'below';
        case 'right':
            return 'right';
        case 'left':
            return 'left';
        /* istanbul ignore next */
        default:
            throw `SkyAffixPlacement does not have a matching value for '${placement}'!`;
    }
}
function parseAffixHorizontalAlignment(alignment) {
    switch (alignment) {
        case 'center':
            return 'center';
        case 'left':
            return 'left';
        case 'right':
            return 'right';
        /* istanbul ignore next */
        default:
            throw `SkyAffixHorizontalAlignment does not have a matching value for '${alignment}'!`;
    }
}

/**
 * @internal
 */
class SkyPopoverContext {
    constructor(args) {
        this.contentTemplateRef = args.contentTemplateRef;
    }
}

/**
 * @internal
 */
class SkyPopoverContentComponent {
    get closed() {
        return this.#_closed.asObservable();
    }
    get opened() {
        return this.#_opened.asObservable();
    }
    get isMouseEnter() {
        return this.#_isMouseEnter.asObservable();
    }
    set isOpen(value) {
        this.#_isOpen = value;
        this.animationState = value ? 'open' : 'closed';
    }
    get isOpen() {
        return this.#_isOpen;
    }
    set contentTarget(value) {
        if (value) {
            value.createEmbeddedView(this.#context.contentTemplateRef);
        }
    }
    #caller;
    #ngUnsubscribe;
    #_closed;
    #_isMouseEnter;
    #_isOpen;
    #_opened;
    #changeDetector;
    #elementRef;
    #affixService;
    #arrowAffixer;
    #coreAdapterService;
    #context;
    #themeSvc;
    constructor(changeDetector, elementRef, affixService, coreAdapterService, context, themeSvc) {
        this.animationState = 'closed';
        this.enableAnimations = true;
        this.horizontalAlignment = 'center';
        this.placement = null;
        this.popoverType = 'info';
        this.#ngUnsubscribe = new Subject();
        this.#_closed = new Subject();
        this.#_isMouseEnter = new Subject();
        this.#_isOpen = false;
        this.#_opened = new Subject();
        this.#changeDetector = changeDetector;
        this.#elementRef = elementRef;
        this.#affixService = affixService;
        this.#coreAdapterService = coreAdapterService;
        this.#context = context;
        this.#themeSvc = themeSvc;
    }
    hasFocusableContent() {
        return (this.#coreAdapterService.getFocusableChildren(this.popoverRef?.nativeElement).length > 0);
    }
    ngOnInit() {
        this.#addEventListeners();
        /*istanbul ignore else*/
        if (this.#themeSvc) {
            this.#themeSvc.settingsChange
                .pipe(takeUntil$1(this.#ngUnsubscribe))
                .subscribe((themeSettings) => {
                /*istanbul ignore next*/
                this.themeName = themeSettings.currentSettings?.theme?.name;
            });
        }
    }
    ngOnDestroy() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
        this.#_closed.complete();
        this.#_isMouseEnter.complete();
        this.#_opened.complete();
        /* istanbul ignore else */
        if (this.affixer) {
            this.affixer.destroy();
            this.affixer = undefined;
        }
        /* istanbul ignore else */
        if (this.#arrowAffixer) {
            this.#arrowAffixer.destroy();
            this.#arrowAffixer = undefined;
        }
    }
    onAnimationEvent(event) {
        if (event.fromState === 'void') {
            return;
        }
        if (event.phaseName === 'done') {
            if (event.toState === 'open') {
                this.#_opened.next();
            }
            else {
                this.#_closed.next();
            }
        }
    }
    open(caller, config) {
        this.#caller = caller;
        this.enableAnimations = config.enableAnimations;
        this.horizontalAlignment = config.horizontalAlignment;
        this.popoverId = config.id;
        this.placement = config.placement;
        this.popoverTitle = config.popoverTitle;
        this.popoverType = config.popoverType;
        this.#changeDetector.markForCheck();
        // Indicates if the popover should be displayed statically.
        // Please note: This feature is internal-only and used by the visual tests to capture multiple
        // states simultaneously without the overhead of event listeners.
        /* istanbul ignore if */
        if (config.isStatic) {
            this.isOpen = true;
            this.#changeDetector.markForCheck();
            return;
        }
        // Let the styles render before gauging the affix dimensions.
        setTimeout(() => {
            /* istanbul ignore if */
            if (!this.popoverRef?.nativeElement || this.#ngUnsubscribe.closed) {
                return;
            }
            if (!this.affixer) {
                this.#setupAffixer();
            }
            const affixOptions = {
                autoFitContext: SkyAffixAutoFitContext.Viewport,
                enableAutoFit: true,
                horizontalAlignment: parseAffixHorizontalAlignment(this.horizontalAlignment),
                isSticky: true,
                placement: parseAffixPlacement(this.placement),
            };
            // Ensure vertical alignment is set according to the popover's placement value.
            if (affixOptions.placement === 'left' ||
                affixOptions.placement === 'right') {
                affixOptions.verticalAlignment = 'middle';
            }
            this.affixer.affixTo(this.#caller?.nativeElement, affixOptions);
            this.#updateArrowOffset();
            this.isOpen = true;
            this.#changeDetector.markForCheck();
        });
    }
    close() {
        this.isOpen = false;
        this.#changeDetector.markForCheck();
    }
    applyFocus() {
        if (this.popoverRef && this.isOpen) {
            this.#coreAdapterService.getFocusableChildrenAndApplyFocus(this.popoverRef, '.sky-popover', true);
        }
    }
    #setupAffixer() {
        if (this.popoverRef) {
            const affixer = this.#affixService.createAffixer(this.popoverRef);
            affixer.placementChange
                .pipe(takeUntil$1(this.#ngUnsubscribe), debounceTime(0, animationFrameScheduler), map((change) => change.placement), distinctUntilChanged())
                .subscribe((placement) => {
                this.placement = placement;
                this.#updateArrowOffset();
                this.#changeDetector.detectChanges();
            });
            this.affixer = affixer;
        }
    }
    #updateArrowOffset() {
        if (this.#caller && this.arrowRef && this.placement) {
            this.#arrowAffixer?.destroy();
            this.#arrowAffixer = this.#affixService.createAffixer(this.arrowRef);
            this.#arrowAffixer.affixTo(this.#caller?.nativeElement, {
                autoFitContext: SkyAffixAutoFitContext.Viewport,
                enableAutoFit: false,
                horizontalAlignment: ['above', 'below'].includes(this.placement)
                    ? 'center'
                    : undefined,
                verticalAlignment: ['left', 'right'].includes(this.placement)
                    ? 'middle'
                    : undefined,
                isSticky: true,
                placement: parseAffixPlacement(this.placement),
                position: 'absolute',
            });
        }
    }
    #isFocusLeavingElement(event) {
        const focusableItems = this.#coreAdapterService.getFocusableChildren(this.#elementRef.nativeElement);
        const isFirstItem = focusableItems[0] === event.target && event.shiftKey;
        const isLastItem = focusableItems[focusableItems.length - 1] === event.target &&
            !event.shiftKey;
        return focusableItems.length === 0 || isFirstItem || isLastItem;
    }
    #addEventListeners() {
        const hostElement = this.#elementRef.nativeElement;
        fromEvent(hostElement, 'mouseenter')
            .pipe(takeUntil$1(this.#ngUnsubscribe))
            .subscribe(() => this.#_isMouseEnter.next(true));
        fromEvent(hostElement, 'mouseleave')
            .pipe(takeUntil$1(this.#ngUnsubscribe))
            .subscribe(() => this.#_isMouseEnter.next(false));
        fromEvent(hostElement, 'keydown')
            .pipe(takeUntil$1(this.#ngUnsubscribe))
            .subscribe((event) => {
            const key = event.key.toLowerCase();
            switch (key) {
                case 'escape':
                    this.close();
                    this.#caller?.nativeElement.focus();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                // Since the popover now lives in an overlay at the bottom of the document body, we need
                // to handle the tab key ourselves. Otherwise, focus would be moved to the browser's
                // search bar.
                case 'tab':
                    /*istanbul ignore else*/
                    if (this.#isFocusLeavingElement(event)) {
                        this.close();
                        this.#caller?.nativeElement.focus();
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    break;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverContentComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i1$1.SkyAffixService }, { token: i1$1.SkyCoreAdapterService }, { token: SkyPopoverContext }, { token: i3$1.SkyThemeService, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.7", type: SkyPopoverContentComponent, isStandalone: false, selector: "sky-popover-content", host: { properties: { "id": "this.popoverId" } }, viewQueries: [{ propertyName: "arrowRef", first: true, predicate: ["arrowRef"], descendants: true, read: ElementRef, static: true }, { propertyName: "popoverRef", first: true, predicate: ["popoverRef"], descendants: true, read: ElementRef, static: true }, { propertyName: "contentTarget", first: true, predicate: ["contentTarget"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<div\n  #popoverRef\n  class=\"sky-popover-container sky-popover-max-height\"\n  [@.disabled]=\"!enableAnimations\"\n  [@skyPopoverAnimation]=\"animationState\"\n  [class.sky-popover-hidden]=\"!placement\"\n  [ngClass]=\"[\n    'sky-popover-alignment-' + horizontalAlignment,\n    'sky-popover-placement-' + placement,\n    'sky-popover-' + popoverType\n  ]\"\n  (@skyPopoverAnimation.done)=\"onAnimationEvent($event)\"\n  (@skyPopoverAnimation.start)=\"onAnimationEvent($event)\"\n>\n  <div\n    class=\"sky-popover\"\n    tabindex=\"-1\"\n    [skyThemeClass]=\"{\n      'sky-rounded-corners sky-shadow': 'default',\n      'sky-elevation-4': 'modern'\n    }\"\n  >\n    @if (popoverTitle) {\n      <div\n        class=\"sky-popover-header\"\n        [skyThemeClass]=\"{\n          'sky-padding-even-default': 'default'\n        }\"\n      >\n        <h4 class=\"sky-popover-title sky-font-heading-4\">\n          {{ popoverTitle }}\n        </h4>\n      </div>\n    }\n    <div\n      class=\"sky-popover-body\"\n      [skyThemeClass]=\"{\n        'sky-padding-even-default': 'default',\n        'sky-padding-even-lg': 'modern'\n      }\"\n    >\n      <ng-container #contentTarget />\n    </div>\n  </div>\n  <span #arrowRef aria-hidden=\"true\" class=\"sky-popover-arrow\"></span>\n</div>\n", styles: [".sky-popover-container:not(.sky-theme-modern *){--sky-override-popover-background-color: #ffffff;--sky-override-popover-max-width: 276px;--sky-override-popover-with-header-top-padding: 2px}:host-context(.sky-theme-modern:not(.sky-theme-brand-base)) .sky-popover-container{--sky-override-popover-accent-border-width: var(--modern-size-6);--sky-override-popover-header-bottom-margin: var(--modern-space-lg);--sky-override-popover-with-header-top-padding: 2px}.sky-popover-container{position:fixed;min-width:276px;max-width:var(--sky-override-popover-max-width, calc(min(var(--sky-size-max_width-overlay_message)) + var(--sky-space-inset-balanced-l) * 2))}.sky-popover-container.sky-popover-hidden{visibility:hidden;opacity:0;pointer-events:none!important}.sky-popover-container.sky-popover-hidden *{pointer-events:none!important}.sky-popover-container.sky-popover-static .sky-popover-arrow{position:absolute}.sky-popover-container:focus{outline:none}@media (max-width: 276px){.sky-popover-container{max-width:100%;min-width:auto}}.sky-popover{background-color:var(--sky-override-popover-background-color, var(--sky-color-background-container-base))}.sky-popover-header{padding-bottom:0}.sky-popover-header+.sky-popover-body{padding-top:var(--sky-override-popover-with-header-top-padding, var(--sky-space-inset-balanced-l))}.sky-popover-title{margin:0}.sky-popover-arrow{display:inline-block;position:absolute;background-color:#00b4f1}.sky-popover-placement-above{padding-bottom:10px}.sky-popover-placement-above .sky-popover{border-bottom:10px solid #00b4f1}.sky-popover-placement-above .sky-popover-arrow{width:30px;height:15px;clip-path:polygon(0 0,50% 95%,100% 0)}.sky-popover-placement-above.sky-popover-danger .sky-popover{border-bottom-color:#ef4044}.sky-popover-placement-above.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-placement-below{padding-top:10px}.sky-popover-placement-below .sky-popover{border-top:10px solid #00b4f1}.sky-popover-placement-below .sky-popover-arrow{width:30px;height:15px;clip-path:polygon(50% 5%,0 100%,100% 100%)}.sky-popover-placement-below.sky-popover-danger .sky-popover{border-top-color:#ef4044}.sky-popover-placement-below.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-placement-right{padding-left:10px}.sky-popover-placement-right .sky-popover{border-left:10px solid #00b4f1}.sky-popover-placement-right .sky-popover-arrow{width:15px;height:30px;clip-path:polygon(5% 50%,100% 100%,100% 0);background-color:#00b4f1}.sky-popover-placement-right.sky-popover-danger .sky-popover{border-left-color:#ef4044}.sky-popover-placement-right.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-placement-left{padding-right:10px}.sky-popover-placement-left .sky-popover{border-right:10px solid #00b4f1}.sky-popover-placement-left .sky-popover-arrow{width:15px;height:30px;clip-path:polygon(0 0,0 100%,95% 50%);background-color:#00b4f1}.sky-popover-placement-left.sky-popover-danger .sky-popover{border-right-color:#ef4044}.sky-popover-placement-left.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-max-height .sky-popover{overflow-y:auto;overflow-x:hidden;min-height:35px;max-height:calc(100vh - min(50px,5vh))}:host-context(.sky-theme-modern) .sky-popover{border-radius:var(--sky-border-radius-s)}:host-context(.sky-theme-modern) .sky-popover-header{padding:var(--sky-override-popover-heading-padding, var(--sky-space-inset-bottomless-top-l) var(--sky-space-inset-bottomless-right-l) var(--sky-space-inset-bottomless-bottom-l) var(--sky-space-inset-bottomless-left-l));margin-bottom:var(--sky-override-popover-header-bottom-margin, 0)}:host-context(.sky-theme-modern) .sky-popover-arrow{background-color:var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-danger .sky-popover-arrow{background-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-above{padding-bottom:10px}:host-context(.sky-theme-modern) .sky-popover-placement-above .sky-popover{border-bottom:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-above .sky-popover-arrow{clip-path:polygon(0 0,45% 88%,50% 92%,55% 88%,100% 0)}:host-context(.sky-theme-modern) .sky-popover-placement-above.sky-popover-danger .sky-popover{border-bottom-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-below{padding-top:10px}:host-context(.sky-theme-modern) .sky-popover-placement-below .sky-popover{border-top:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-below .sky-popover-arrow{clip-path:polygon(0 100%,45% 12%,50% 8%,55% 12%,100% 100%)}:host-context(.sky-theme-modern) .sky-popover-placement-below.sky-popover-danger .sky-popover{border-top-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-right{padding-left:10px}:host-context(.sky-theme-modern) .sky-popover-placement-right .sky-popover{border-left:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-right .sky-popover-arrow{clip-path:polygon(100% 0,12% 45%,8% 50%,12% 55%,100% 100%)}:host-context(.sky-theme-modern) .sky-popover-placement-right.sky-popover-danger .sky-popover{border-left-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-left{padding-right:10px}:host-context(.sky-theme-modern) .sky-popover-placement-left .sky-popover{border-right:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-left .sky-popover-arrow{clip-path:polygon(0 0,88% 45%,92% 50%,88% 55%,0 100%)}:host-context(.sky-theme-modern) .sky-popover-placement-left.sky-popover-danger .sky-popover{border-right-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover{border-radius:var(--sky-border-radius-s)}.sky-theme-modern .sky-popover-header{padding:var(--sky-override-popover-heading-padding, var(--sky-space-inset-bottomless-top-l) var(--sky-space-inset-bottomless-right-l) var(--sky-space-inset-bottomless-bottom-l) var(--sky-space-inset-bottomless-left-l));margin-bottom:var(--sky-override-popover-header-bottom-margin, 0)}.sky-theme-modern .sky-popover-arrow{background-color:var(--sky-color-border-info)}.sky-theme-modern .sky-popover-danger .sky-popover-arrow{background-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-above{padding-bottom:10px}.sky-theme-modern .sky-popover-placement-above .sky-popover{border-bottom:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-above .sky-popover-arrow{clip-path:polygon(0 0,45% 88%,50% 92%,55% 88%,100% 0)}.sky-theme-modern .sky-popover-placement-above.sky-popover-danger .sky-popover{border-bottom-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-below{padding-top:10px}.sky-theme-modern .sky-popover-placement-below .sky-popover{border-top:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-below .sky-popover-arrow{clip-path:polygon(0 100%,45% 12%,50% 8%,55% 12%,100% 100%)}.sky-theme-modern .sky-popover-placement-below.sky-popover-danger .sky-popover{border-top-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-right{padding-left:10px}.sky-theme-modern .sky-popover-placement-right .sky-popover{border-left:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-right .sky-popover-arrow{clip-path:polygon(100% 0,12% 45%,8% 50%,12% 55%,100% 100%)}.sky-theme-modern .sky-popover-placement-right.sky-popover-danger .sky-popover{border-left-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-left{padding-right:10px}.sky-theme-modern .sky-popover-placement-left .sky-popover{border-right:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-left .sky-popover-arrow{clip-path:polygon(0 0,88% 45%,92% 50%,88% 55%,0 100%)}.sky-theme-modern .sky-popover-placement-left.sky-popover-danger .sky-popover{border-right-color:var(--sky-color-border-danger)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3$1.λ2, selector: "[skyThemeClass]", inputs: ["class", "skyThemeClass"] }], animations: [skyPopoverAnimation] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-popover-content', animations: [skyPopoverAnimation], standalone: false, template: "<div\n  #popoverRef\n  class=\"sky-popover-container sky-popover-max-height\"\n  [@.disabled]=\"!enableAnimations\"\n  [@skyPopoverAnimation]=\"animationState\"\n  [class.sky-popover-hidden]=\"!placement\"\n  [ngClass]=\"[\n    'sky-popover-alignment-' + horizontalAlignment,\n    'sky-popover-placement-' + placement,\n    'sky-popover-' + popoverType\n  ]\"\n  (@skyPopoverAnimation.done)=\"onAnimationEvent($event)\"\n  (@skyPopoverAnimation.start)=\"onAnimationEvent($event)\"\n>\n  <div\n    class=\"sky-popover\"\n    tabindex=\"-1\"\n    [skyThemeClass]=\"{\n      'sky-rounded-corners sky-shadow': 'default',\n      'sky-elevation-4': 'modern'\n    }\"\n  >\n    @if (popoverTitle) {\n      <div\n        class=\"sky-popover-header\"\n        [skyThemeClass]=\"{\n          'sky-padding-even-default': 'default'\n        }\"\n      >\n        <h4 class=\"sky-popover-title sky-font-heading-4\">\n          {{ popoverTitle }}\n        </h4>\n      </div>\n    }\n    <div\n      class=\"sky-popover-body\"\n      [skyThemeClass]=\"{\n        'sky-padding-even-default': 'default',\n        'sky-padding-even-lg': 'modern'\n      }\"\n    >\n      <ng-container #contentTarget />\n    </div>\n  </div>\n  <span #arrowRef aria-hidden=\"true\" class=\"sky-popover-arrow\"></span>\n</div>\n", styles: [".sky-popover-container:not(.sky-theme-modern *){--sky-override-popover-background-color: #ffffff;--sky-override-popover-max-width: 276px;--sky-override-popover-with-header-top-padding: 2px}:host-context(.sky-theme-modern:not(.sky-theme-brand-base)) .sky-popover-container{--sky-override-popover-accent-border-width: var(--modern-size-6);--sky-override-popover-header-bottom-margin: var(--modern-space-lg);--sky-override-popover-with-header-top-padding: 2px}.sky-popover-container{position:fixed;min-width:276px;max-width:var(--sky-override-popover-max-width, calc(min(var(--sky-size-max_width-overlay_message)) + var(--sky-space-inset-balanced-l) * 2))}.sky-popover-container.sky-popover-hidden{visibility:hidden;opacity:0;pointer-events:none!important}.sky-popover-container.sky-popover-hidden *{pointer-events:none!important}.sky-popover-container.sky-popover-static .sky-popover-arrow{position:absolute}.sky-popover-container:focus{outline:none}@media (max-width: 276px){.sky-popover-container{max-width:100%;min-width:auto}}.sky-popover{background-color:var(--sky-override-popover-background-color, var(--sky-color-background-container-base))}.sky-popover-header{padding-bottom:0}.sky-popover-header+.sky-popover-body{padding-top:var(--sky-override-popover-with-header-top-padding, var(--sky-space-inset-balanced-l))}.sky-popover-title{margin:0}.sky-popover-arrow{display:inline-block;position:absolute;background-color:#00b4f1}.sky-popover-placement-above{padding-bottom:10px}.sky-popover-placement-above .sky-popover{border-bottom:10px solid #00b4f1}.sky-popover-placement-above .sky-popover-arrow{width:30px;height:15px;clip-path:polygon(0 0,50% 95%,100% 0)}.sky-popover-placement-above.sky-popover-danger .sky-popover{border-bottom-color:#ef4044}.sky-popover-placement-above.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-placement-below{padding-top:10px}.sky-popover-placement-below .sky-popover{border-top:10px solid #00b4f1}.sky-popover-placement-below .sky-popover-arrow{width:30px;height:15px;clip-path:polygon(50% 5%,0 100%,100% 100%)}.sky-popover-placement-below.sky-popover-danger .sky-popover{border-top-color:#ef4044}.sky-popover-placement-below.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-placement-right{padding-left:10px}.sky-popover-placement-right .sky-popover{border-left:10px solid #00b4f1}.sky-popover-placement-right .sky-popover-arrow{width:15px;height:30px;clip-path:polygon(5% 50%,100% 100%,100% 0);background-color:#00b4f1}.sky-popover-placement-right.sky-popover-danger .sky-popover{border-left-color:#ef4044}.sky-popover-placement-right.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-placement-left{padding-right:10px}.sky-popover-placement-left .sky-popover{border-right:10px solid #00b4f1}.sky-popover-placement-left .sky-popover-arrow{width:15px;height:30px;clip-path:polygon(0 0,0 100%,95% 50%);background-color:#00b4f1}.sky-popover-placement-left.sky-popover-danger .sky-popover{border-right-color:#ef4044}.sky-popover-placement-left.sky-popover-danger .sky-popover-arrow{background-color:#ef4044}.sky-popover-max-height .sky-popover{overflow-y:auto;overflow-x:hidden;min-height:35px;max-height:calc(100vh - min(50px,5vh))}:host-context(.sky-theme-modern) .sky-popover{border-radius:var(--sky-border-radius-s)}:host-context(.sky-theme-modern) .sky-popover-header{padding:var(--sky-override-popover-heading-padding, var(--sky-space-inset-bottomless-top-l) var(--sky-space-inset-bottomless-right-l) var(--sky-space-inset-bottomless-bottom-l) var(--sky-space-inset-bottomless-left-l));margin-bottom:var(--sky-override-popover-header-bottom-margin, 0)}:host-context(.sky-theme-modern) .sky-popover-arrow{background-color:var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-danger .sky-popover-arrow{background-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-above{padding-bottom:10px}:host-context(.sky-theme-modern) .sky-popover-placement-above .sky-popover{border-bottom:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-above .sky-popover-arrow{clip-path:polygon(0 0,45% 88%,50% 92%,55% 88%,100% 0)}:host-context(.sky-theme-modern) .sky-popover-placement-above.sky-popover-danger .sky-popover{border-bottom-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-below{padding-top:10px}:host-context(.sky-theme-modern) .sky-popover-placement-below .sky-popover{border-top:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-below .sky-popover-arrow{clip-path:polygon(0 100%,45% 12%,50% 8%,55% 12%,100% 100%)}:host-context(.sky-theme-modern) .sky-popover-placement-below.sky-popover-danger .sky-popover{border-top-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-right{padding-left:10px}:host-context(.sky-theme-modern) .sky-popover-placement-right .sky-popover{border-left:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-right .sky-popover-arrow{clip-path:polygon(100% 0,12% 45%,8% 50%,12% 55%,100% 100%)}:host-context(.sky-theme-modern) .sky-popover-placement-right.sky-popover-danger .sky-popover{border-left-color:var(--sky-color-border-danger)}:host-context(.sky-theme-modern) .sky-popover-placement-left{padding-right:10px}:host-context(.sky-theme-modern) .sky-popover-placement-left .sky-popover{border-right:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}:host-context(.sky-theme-modern) .sky-popover-placement-left .sky-popover-arrow{clip-path:polygon(0 0,88% 45%,92% 50%,88% 55%,0 100%)}:host-context(.sky-theme-modern) .sky-popover-placement-left.sky-popover-danger .sky-popover{border-right-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover{border-radius:var(--sky-border-radius-s)}.sky-theme-modern .sky-popover-header{padding:var(--sky-override-popover-heading-padding, var(--sky-space-inset-bottomless-top-l) var(--sky-space-inset-bottomless-right-l) var(--sky-space-inset-bottomless-bottom-l) var(--sky-space-inset-bottomless-left-l));margin-bottom:var(--sky-override-popover-header-bottom-margin, 0)}.sky-theme-modern .sky-popover-arrow{background-color:var(--sky-color-border-info)}.sky-theme-modern .sky-popover-danger .sky-popover-arrow{background-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-above{padding-bottom:10px}.sky-theme-modern .sky-popover-placement-above .sky-popover{border-bottom:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-above .sky-popover-arrow{clip-path:polygon(0 0,45% 88%,50% 92%,55% 88%,100% 0)}.sky-theme-modern .sky-popover-placement-above.sky-popover-danger .sky-popover{border-bottom-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-below{padding-top:10px}.sky-theme-modern .sky-popover-placement-below .sky-popover{border-top:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-below .sky-popover-arrow{clip-path:polygon(0 100%,45% 12%,50% 8%,55% 12%,100% 100%)}.sky-theme-modern .sky-popover-placement-below.sky-popover-danger .sky-popover{border-top-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-right{padding-left:10px}.sky-theme-modern .sky-popover-placement-right .sky-popover{border-left:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-right .sky-popover-arrow{clip-path:polygon(100% 0,12% 45%,8% 50%,12% 55%,100% 100%)}.sky-theme-modern .sky-popover-placement-right.sky-popover-danger .sky-popover{border-left-color:var(--sky-color-border-danger)}.sky-theme-modern .sky-popover-placement-left{padding-right:10px}.sky-theme-modern .sky-popover-placement-left .sky-popover{border-right:var(--sky-override-popover-accent-border-width, var(--sky-border-width-accent)) var(--sky-border-style-accent) var(--sky-color-border-info)}.sky-theme-modern .sky-popover-placement-left .sky-popover-arrow{clip-path:polygon(0 0,88% 45%,92% 50%,88% 55%,0 100%)}.sky-theme-modern .sky-popover-placement-left.sky-popover-danger .sky-popover{border-right-color:var(--sky-color-border-danger)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i1$1.SkyAffixService }, { type: i1$1.SkyCoreAdapterService }, { type: SkyPopoverContext }, { type: i3$1.SkyThemeService, decorators: [{
                    type: Optional
                }] }], propDecorators: { popoverId: [{
                type: HostBinding,
                args: ['id']
            }], arrowRef: [{
                type: ViewChild,
                args: ['arrowRef', {
                        read: ElementRef,
                        static: true,
                    }]
            }], popoverRef: [{
                type: ViewChild,
                args: ['popoverRef', {
                        read: ElementRef,
                        static: true,
                    }]
            }], contentTarget: [{
                type: ViewChild,
                args: ['contentTarget', {
                        read: ViewContainerRef,
                        static: true,
                    }]
            }] } });

class SkyPopoverComponent {
    /**
     * The horizontal alignment of the popover in relation to the trigger element.
     * The `skyPopoverAlignment` property on the popover directive takes precedence over this property when specified.
     * @default "center"
     */
    set alignment(value) {
        this.#_alignment = value ?? 'center';
    }
    get alignment() {
        return this.#_alignment;
    }
    /**
     * The placement of the popover in relation to the trigger element.
     * The `skyPopoverPlacement` property on the popover directive takes precedence over this property when specified.
     * @default "above"
     */
    set placement(value) {
        this.#_placement = value ?? 'above';
    }
    get placement() {
        return this.#_placement;
    }
    /**
     * The type of popover.
     * @default "info"
     */
    set popoverType(value) {
        this.#_popoverType = value ?? 'info';
    }
    get popoverType() {
        return this.#_popoverType;
    }
    #contentRef;
    #isMarkedForCloseOnMouseLeave;
    #ngUnsubscribe;
    #overlay;
    #_alignment;
    #_placement;
    #_popoverType;
    #environmentInjector;
    #overlayService;
    #zIndex;
    constructor(overlayService, stackingContext) {
        /**
         * Fires when users close the popover.
         */
        this.popoverClosed = new EventEmitter();
        /**
         * Fires when users open the popover.
         */
        this.popoverOpened = new EventEmitter();
        /**
         * Whether the popover is in the process of being opened or closed.
         * @internal
         */
        this.isActive = false;
        /**
         * Used by unit tests to disable animations since the component is injected at the bottom of the
         * document body.
         * @internal
         */
        this.enableAnimations = true;
        this.isMouseEnter = false;
        this.#isMarkedForCloseOnMouseLeave = false;
        this.#ngUnsubscribe = new Subject();
        this.#_alignment = 'center';
        this.#_placement = 'above';
        this.#_popoverType = 'info';
        this.#environmentInjector = inject(EnvironmentInjector);
        this.#overlayService = overlayService;
        this.#zIndex = stackingContext?.zIndex;
        this.popoverId = inject(SkyIdService).generateId();
    }
    ngOnDestroy() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
        if (this.#overlay) {
            this.#overlayService.close(this.#overlay);
            this.#overlay = undefined;
        }
    }
    /**
     * Positions the popover next to a given caller element.
     * @param caller The element that opened the popover.
     * @param placement The placement of the popover.
     * @param alignment The horizontal alignment of the popover.
     * @internal
     */
    positionNextTo(caller, placement, alignment) {
        if (!this.#overlay) {
            this.#setupOverlay();
        }
        this.placement = placement ?? this.placement;
        this.alignment = alignment ?? this.alignment;
        this.isActive = true;
        this.#contentRef.open(caller, {
            enableAnimations: this.enableAnimations,
            horizontalAlignment: this.alignment,
            id: this.popoverId,
            isStatic: false,
            placement: this.placement,
            popoverTitle: this.popoverTitle,
            popoverType: this.popoverType,
        });
    }
    /**
     * Closes the popover.
     * @internal
     */
    close() {
        /*istanbul ignore next*/
        this.#contentRef?.close();
    }
    /**
     * Brings focus to the popover element if its open.
     * @internal
     */
    applyFocus() {
        /*istanbul ignore next*/
        this.#contentRef?.applyFocus();
    }
    /**
     * Adds a flag to the popover to close when the mouse leaves the popover's bounds.
     * @internal
     */
    markForCloseOnMouseLeave() {
        this.#isMarkedForCloseOnMouseLeave = true;
    }
    hasFocusableContent() {
        return this.#contentRef.hasFocusableContent();
    }
    #setupOverlay() {
        if (this.templateRef) {
            const overlay = this.#overlayService.create({
                enableScroll: true,
                enablePointerEvents: true,
                environmentInjector: this.#environmentInjector,
            });
            if (this.#zIndex) {
                this.#zIndex
                    .pipe(takeUntil(this.#ngUnsubscribe))
                    .subscribe((zIndex) => {
                    overlay.componentRef.instance.zIndex = zIndex.toString(10);
                });
            }
            overlay.backdropClick
                .pipe(takeUntil(this.#ngUnsubscribe))
                .subscribe(() => {
                this.close();
            });
            const contentRef = overlay.attachComponent(SkyPopoverContentComponent, [
                {
                    provide: SkyPopoverContext,
                    useValue: new SkyPopoverContext({
                        contentTemplateRef: this.templateRef,
                    }),
                },
            ]);
            contentRef.opened.pipe(takeUntil(this.#ngUnsubscribe)).subscribe(() => {
                this.popoverOpened.emit(this);
            });
            contentRef.closed.pipe(takeUntil(this.#ngUnsubscribe)).subscribe(() => {
                /*istanbul ignore else*/
                if (this.isActive && this.#overlay) {
                    this.#overlayService.close(this.#overlay);
                    this.#overlay = undefined;
                    this.isActive = false;
                    this.popoverClosed.emit(this);
                }
            });
            contentRef.isMouseEnter
                .pipe(takeUntil(this.#ngUnsubscribe))
                .subscribe((isMouseEnter) => {
                this.isMouseEnter = isMouseEnter;
                if (this.#isMarkedForCloseOnMouseLeave) {
                    this.#isMarkedForCloseOnMouseLeave = false;
                    this.close();
                }
            });
            this.#overlay = overlay;
            this.#contentRef = contentRef;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverComponent, deps: [{ token: i1$1.SkyOverlayService }, { token: SKY_STACKING_CONTEXT, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.7", type: SkyPopoverComponent, isStandalone: false, selector: "sky-popover", inputs: { alignment: "alignment", placement: "placement", popoverTitle: "popoverTitle", popoverType: "popoverType" }, outputs: { popoverClosed: "popoverClosed", popoverOpened: "popoverOpened" }, viewQueries: [{ propertyName: "templateRef", first: true, predicate: ["templateRef"], descendants: true, read: TemplateRef, static: true }], ngImport: i0, template: "<ng-template #templateRef>\n  <ng-content />\n</ng-template>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-popover', standalone: false, template: "<ng-template #templateRef>\n  <ng-content />\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1$1.SkyOverlayService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SKY_STACKING_CONTEXT]
                }] }], propDecorators: { alignment: [{
                type: Input
            }], placement: [{
                type: Input
            }], popoverTitle: [{
                type: Input
            }], popoverType: [{
                type: Input
            }], popoverClosed: [{
                type: Output
            }], popoverOpened: [{
                type: Output
            }], templateRef: [{
                type: ViewChild,
                args: ['templateRef', {
                        read: TemplateRef,
                        static: true,
                    }]
            }] } });

/**
 * Inserts an empty "pointer" element after the host element to direct screen
 * readers to the opened popover content. Popover content is appended to the
 * document body, but it needs to be associated with the host element to meet
 * accessibility requirements. This is done by setting `aria-owns` on the
 * pointer element, which instructs the screen reader to consider the popover
 * contents as a child of the pointer element. We cannot set `aria-owns` on
 * the host element because it is nearly always a button, and buttons cannot
 * have block-level children.
 * @see https://github.com/w3c/html-aria/issues/124
 * @internal
 */
class SkyPopoverSRPointerService {
    #srPointerEl;
    #renderer = inject(Renderer2);
    #srPointerId = inject(SkyIdService).generateId();
    #hostEl = inject((ElementRef));
    ngOnDestroy() {
        this.destroySRPointerEl();
    }
    createSRPointerEl() {
        const pointerEl = this.#renderer.createElement('span');
        this.#renderer.setAttribute(pointerEl, 'id', this.#srPointerId);
        this.#srPointerEl = pointerEl;
        const hostEl = this.#hostEl?.nativeElement;
        this.#renderer.setAttribute(hostEl, 'aria-controls', this.#srPointerId);
        hostEl?.parentNode?.insertBefore(pointerEl, hostEl.nextSibling);
    }
    destroySRPointerEl() {
        this.#srPointerEl?.remove();
        this.#srPointerEl = undefined;
    }
    updateAriaAttributes(options) {
        const hostEl = this.#hostEl?.nativeElement;
        const pointerEl = this.#srPointerEl;
        // Only set attributes if the pointer element exists.
        if (pointerEl) {
            this.#renderer.setAttribute(hostEl, 'aria-expanded', options.ariaExpanded ? 'true' : 'false');
            if (options.ariaExpanded === true) {
                if (options.ariaOwns) {
                    this.#renderer.setAttribute(pointerEl, 'aria-owns', options.ariaOwns);
                }
            }
            else {
                this.#renderer.removeAttribute(pointerEl, 'aria-owns');
            }
        }
        else {
            this.#renderer.removeAttribute(hostEl, 'aria-expanded');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverSRPointerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverSRPointerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverSRPointerService, decorators: [{
            type: Injectable
        }] });

/**
 * The type of message to send to the popover component.
 */
var SkyPopoverMessageType;
(function (SkyPopoverMessageType) {
    /**
     * Opens the popover.
     */
    SkyPopoverMessageType[SkyPopoverMessageType["Open"] = 0] = "Open";
    /**
     * Closes the popover.
     */
    SkyPopoverMessageType[SkyPopoverMessageType["Close"] = 1] = "Close";
    /**
     * Repositions the popover to the appropriate position.
     * This is useful for when the popover's width and height change while it is open.
     */
    SkyPopoverMessageType[SkyPopoverMessageType["Reposition"] = 2] = "Reposition";
    /**
     * Brings focus to the popover element.
     */
    SkyPopoverMessageType[SkyPopoverMessageType["Focus"] = 3] = "Focus";
})(SkyPopoverMessageType || (SkyPopoverMessageType = {}));

class SkyPopoverDirective {
    /**
     * The popover component to display. Add this directive to the trigger element that opens the popover.
     * @required
     */
    set skyPopover(value) {
        this.popoverId = value?.popoverId;
        this.#_popover = value;
        this.#updateSRPointer(value);
    }
    get skyPopover() {
        return this.#_popover;
    }
    /**
     * The RxJS `Subject` to send commands to the popover that respect the `SkyPopoverMessage` type.
     */
    set skyPopoverMessageStream(value) {
        this.#_skyPopoverMessageStream = value ?? new Subject();
        this.#subscribeMessageStream();
    }
    get skyPopoverMessageStream() {
        return this.#_skyPopoverMessageStream;
    }
    #_skyPopoverMessageStream;
    #messageStreamSub;
    /**
     * The user action that displays the popover.
     * @deprecated To ensure usability on touch devices, trigger user-invoked
     * popovers on `click` actions rather than `mouseenter` actions.
     */
    set skyPopoverTrigger(value) {
        this.#_trigger = value ?? 'click';
        this.#updateAriaAttributes();
    }
    get skyPopoverTrigger() {
        return this.#_trigger;
    }
    #ngUnsubscribe;
    #_popover;
    #_trigger;
    #elementRef;
    #expanded;
    #popoverClosedSubscription;
    #srPointerSvc;
    constructor(elementRef) {
        /**
         * Appends the `sky-popover-trigger` class to the trigger element.
         * @internal
         */
        this.directiveClass = 'sky-popover-trigger';
        this.#_skyPopoverMessageStream = new Subject();
        this.#ngUnsubscribe = new Subject();
        this.#_trigger = 'click';
        this.#expanded = false;
        this.#srPointerSvc = inject(SkyPopoverSRPointerService);
        this.#elementRef = elementRef;
        this.#subscribeMessageStream();
    }
    ngOnInit() {
        this.#addEventListeners();
    }
    ngOnDestroy() {
        this.#removeEventListeners();
        this.#unsubscribeMessageStream();
        this.#popoverClosedSubscription?.unsubscribe();
    }
    togglePopover() {
        if (this.skyPopover?.isActive) {
            this.#sendMessage(SkyPopoverMessageType.Close);
            return;
        }
        this.#sendMessage(SkyPopoverMessageType.Open);
    }
    #positionPopover() {
        this.skyPopover?.positionNextTo(this.#elementRef, this.skyPopoverPlacement, this.skyPopoverAlignment);
    }
    #closePopover() {
        this.skyPopover?.close();
    }
    #closePopoverOrMarkForClose() {
        if (this.skyPopover?.isMouseEnter) {
            this.skyPopover.markForCloseOnMouseLeave();
        }
        else {
            this.#sendMessage(SkyPopoverMessageType.Close);
        }
    }
    #addEventListeners() {
        const element = this.#elementRef.nativeElement;
        fromEvent(element, 'keydown')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((event) => {
            if (!this.skyPopover?.isActive) {
                return;
            }
            const key = event.key.toLowerCase();
            switch (key) {
                case 'escape':
                    this.#sendMessage(SkyPopoverMessageType.Close);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'tab':
                    if (this.skyPopover.hasFocusableContent()) {
                        this.#sendMessage(SkyPopoverMessageType.Focus);
                        event.stopPropagation();
                        event.preventDefault();
                    }
                    else {
                        this.#sendMessage(SkyPopoverMessageType.Close);
                    }
                    break;
            }
        });
        fromEvent(element, 'click')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            if (this.skyPopover) {
                this.togglePopover();
            }
        });
        fromEvent(element, 'mouseenter')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            if (this.skyPopover) {
                this.skyPopover.isMouseEnter = true;
                if (!this.skyPopover.isActive &&
                    this.skyPopoverTrigger === 'mouseenter') {
                    this.#sendMessage(SkyPopoverMessageType.Open);
                }
            }
        });
        fromEvent(element, 'mouseleave')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            if (this.skyPopover) {
                this.skyPopover.isMouseEnter = false;
                if (this.skyPopover.isActive &&
                    this.skyPopoverTrigger === 'mouseenter') {
                    if (document.activeElement !== element) {
                        // Give the popover a chance to set its isMouseEnter flag before checking to see
                        // if it should be closed.
                        setTimeout(() => {
                            this.#closePopoverOrMarkForClose();
                        });
                    }
                }
            }
        });
        fromEvent(element, 'focusin')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            if (this.skyPopover) {
                if (!this.skyPopover.isActive &&
                    this.skyPopoverTrigger === 'mouseenter') {
                    this.#sendMessage(SkyPopoverMessageType.Open);
                }
            }
        });
        fromEvent(element, 'focusout')
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe(() => {
            if (this.skyPopover) {
                if (this.skyPopover.isActive &&
                    this.skyPopoverTrigger === 'mouseenter') {
                    this.#sendMessage(SkyPopoverMessageType.Close);
                }
            }
        });
    }
    #removeEventListeners() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
    }
    #handleIncomingMessages(message) {
        switch (message.type) {
            case SkyPopoverMessageType.Open:
                this.#positionPopover();
                this.#expanded = true;
                this.#updateAriaAttributes();
                break;
            case SkyPopoverMessageType.Close:
                /*istanbul ignore else*/
                if (this.skyPopover?.isActive) {
                    this.#closePopover();
                }
                break;
            case SkyPopoverMessageType.Reposition:
                // Only reposition the popover if it is already open.
                if (this.skyPopover?.isActive) {
                    this.#positionPopover();
                }
                break;
            case SkyPopoverMessageType.Focus:
                this.skyPopover?.applyFocus();
                break;
        }
    }
    #sendMessage(messageType) {
        this.skyPopoverMessageStream.next({ type: messageType });
    }
    #subscribeMessageStream() {
        this.#unsubscribeMessageStream();
        this.#messageStreamSub = this.skyPopoverMessageStream.subscribe((message) => {
            this.#handleIncomingMessages(message);
        });
    }
    #unsubscribeMessageStream() {
        if (this.#messageStreamSub) {
            this.#messageStreamSub.unsubscribe();
            this.#messageStreamSub = undefined;
        }
    }
    #updateAriaAttributes() {
        this.#srPointerSvc.updateAriaAttributes({
            ariaExpanded: this.#expanded,
            ariaOwns: this.popoverId,
        });
    }
    #updateSRPointer(popover) {
        this.#popoverClosedSubscription?.unsubscribe();
        this.#popoverClosedSubscription = popover
            ? popover.popoverClosed.subscribe(() => {
                this.#expanded = false;
                this.#updateAriaAttributes();
            })
            : undefined;
        if (popover) {
            if (this.skyPopoverTrigger === 'click') {
                this.#srPointerSvc.createSRPointerEl();
            }
        }
        else {
            this.#srPointerSvc.destroySRPointerEl();
        }
        this.#updateAriaAttributes();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.7", type: SkyPopoverDirective, isStandalone: false, selector: "[skyPopover]", inputs: { skyPopover: "skyPopover", skyPopoverAlignment: "skyPopoverAlignment", skyPopoverMessageStream: "skyPopoverMessageStream", skyPopoverPlacement: "skyPopoverPlacement", skyPopoverTrigger: "skyPopoverTrigger" }, host: { properties: { "class": "this.directiveClass" } }, providers: [SkyPopoverSRPointerService], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverDirective, decorators: [{
            type: Directive,
            args: [{
                    providers: [SkyPopoverSRPointerService],
                    selector: '[skyPopover]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { directiveClass: [{
                type: HostBinding,
                args: ['class']
            }], skyPopover: [{
                type: Input
            }], skyPopoverAlignment: [{
                type: Input
            }], skyPopoverMessageStream: [{
                type: Input
            }], skyPopoverPlacement: [{
                type: Input
            }], skyPopoverTrigger: [{
                type: Input
            }] } });

class SkyPopoverModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverModule, declarations: [SkyPopoverComponent,
            SkyPopoverContentComponent,
            SkyPopoverDirective], imports: [CommonModule,
            SkyAffixModule,
            SkyIconModule,
            SkyPopoversResourcesModule,
            SkyThemeModule], exports: [SkyPopoverComponent,
            SkyPopoverContentComponent,
            SkyPopoverDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverModule, imports: [CommonModule,
            SkyAffixModule,
            SkyIconModule,
            SkyPopoversResourcesModule,
            SkyThemeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.7", ngImport: i0, type: SkyPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SkyPopoverComponent,
                        SkyPopoverContentComponent,
                        SkyPopoverDirective,
                    ],
                    imports: [
                        CommonModule,
                        SkyAffixModule,
                        SkyIconModule,
                        SkyPopoversResourcesModule,
                        SkyThemeModule,
                    ],
                    exports: [
                        SkyPopoverComponent,
                        SkyPopoverContentComponent,
                        SkyPopoverDirective,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SkyDropdownMessageType, SkyDropdownModule, SkyPopoverMessageType, SkyPopoverModule, SkyDropdownItemComponent as λ1, SkyDropdownButtonComponent as λ2, SkyDropdownComponent as λ3, SkyDropdownMenuComponent as λ4, SkyPopoverContentComponent as λ5, SkyPopoverComponent as λ6, SkyPopoverDirective as λ7, SkyDropdownTriggerDirective as λ8 };
